import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import {
    Box,
    Drawer,
    Divider,
    TextField,
    Grid,
    Button,
    IconButton,
    Menu,
    useTheme,
    styled,
    Toolbar,
    CssBaseline,
    Switch,
    Typography,
    Tooltip,
    MenuItem,
    Modal,
} from '@mui/material';
import { Call, RemoveRedEye, LocalPhone, PhoneDisabled, RingVolume, PermIdentity, Keyboard, NoteAlt, PeopleOutline, Mic, MicOff, Redo, Pause, PlayArrow, Cancel, VolumeOff, VolumeUp } from '@mui/icons-material';
import BackspaceIcon from '@mui/icons-material/Backspace';
import AddIcon from '@mui/icons-material/Add';
import {
    UserAgent,
    Inviter,
    SessionState,
    Registerer,
    RegistererState,
} from 'sip.js';
import axios from 'axios';
import { global_link, socket_base_url, socketiopath, audio_socket_base_url, audio_socket_path } from './Globallink';
import { useTimer } from './Timer';
import modalStyle from './ModalStyle';
import { io } from 'socket.io-client';
import WebSocketContext from '../Context/WebSocket';
import { jwtDecode } from 'jwt-decode';

// Plain mic capture: browser-default mic processing.
const SIP_AUDIO_CONSTRAINTS = { audio: true, video: false };


const DialBar = ({ onClose, children }) => {
    const api = axios.create({ baseURL: global_link });
    const authToken = process.env.AUTH_TOKEN;
    const authyToken = localStorage.getItem(authToken);
    const [searchText, setSearchText] = useState('');
    const [dialdisplay, setDialDisplay] = useState('');
    const [selectedDailerTab, setSelectedDailerTab] = useState(0);
    const [hideCallButtonsAccept, setHideCallButtonsAccept] = useState(true);
    const [showConnecting, setShowConnecting] = useState('');
    const [transferExtension, setTransferExtension] = useState('');
    const [transferToUsers, setTransferToUsers] = useState([]);
    const [externalDisplay, setExternalDisplay] = useState('');
    const [externalAttendedDisplay, setExternalAttendedDisplay] = useState('');

    // Warm Transfer
    const [consultationSession, setConsultationSession] = useState(null);
    const [isInWarmTransfer, setIsInWarmTransfer] = useState(false);
    const [warmTransferTarget, setWarmTransferTarget] = useState('');
    const [isConsultationReady, setIsConsultationReady] = useState(false);
    const [unattendedInternalStatus, setUnattendedInternalStatus] = useState(false);

    // ── 3-Party Conference (browser-mixed, no FreeSWITCH bridge) ───────────────
    const [conferencePanel, setConferencePanel] = useState(false);   // dial panel open
    const [conferenceDisplay, setConferenceDisplay] = useState('');  // number being dialed for conf
    const [conferenceStatus, setConferenceStatus] = useState('');    // human-readable status line
    const [isConfDialing, setIsConfDialing] = useState(false);       // child leg ringing
    const [isConfReady, setIsConfReady] = useState(false);           // child leg established, awaiting merge
    const [isConfJoined, setIsConfJoined] = useState(false);         // all three parties merged

    // The second SIP leg (agent <-> third party). Independent of the parent call.
    const conferenceSessionRef = useRef(null);
    // Pristine mic tracks captured BEFORE any mixed track is swapped in, one per
    // peer connection. Restored on teardown so senders return to raw mic audio.
    const parentMicTrackRef = useRef(null);  // parent PC's original outgoing mic track
    const confMicTrackRef = useRef(null);    // child PC's original outgoing mic track
    // AudioContexts created for the two mixers — closed on teardown to free HW.
    const mixCtxRefs = useRef([]);
    // Guard so teardown can only run once even if multiple end-events race.
    const confTeardownGuardRef = useRef(false);

    // Mirror mute/hold into refs so promise callbacks (post replaceTrack) read
    // the CURRENT value, not a value captured at closure-creation time.
    const isMutedRef = useRef(false);
    const isHeldRef = useRef(false);

    // DIALER STATE CHANGES
    const [displayInput, setDisplayInput] = useState(true);
    const [dialerButtons, setDialerButtons] = useState(true);
    const [showIncomingCall, setShowIncomingCall] = useState(false);
    const [isRinging, setRinging] = useState('MAKING CALL');
    const [showMakingCall, setMakingCall] = useState(false);
    const [showacceptedCall, setAcceptedCall] = useState(false);
    const { timer, startTimer, resetTimer, getCurrentTimer } = useTimer();
    const [dialerNumber, setDialerNumber] = useState('');
    const [contactName, setContactName] = useState('');
    // Phone associated with the live lookup result — used when the user clicks the name
    const [matchedContactPhone, setMatchedContactPhone] = useState('');
    // Multiple dialer search hits (same name / several numbers) — each row is tappable
    const [contactMatches, setContactMatches] = useState([]);
    const [dtmfButtons, setDtmfButtons] = useState(false);
    const [incomingNumber, setIncomingNumber] = useState('');
    const [dTMFValue, setDTMFValue] = useState('');
    const [transferCalls, setTransferCalls] = useState(false);
    const [externalTransferCalls, setExternalTransferCalls] = useState(false);
    const [externalAttendedTransferCalls, setExternalAttendedTransferCalls] = useState(false);
    const [transferSelection, setTransferSelection] = useState(false);
    const [transferSelectionValue, setTransferSelectionValue] = useState('');
    const [dispositionList, setDispositionList] = useState([]);
    const [newDisposition, setNewDisposition] = useState({
        user_name: '',
        disposition_contact: '',
        disposition: '',
        disposition_info: '',
        call_type: '',
        disposition_time: '',
    });
    const [openAddDispositionModal, setAddDispositionModal] = useState(false);
    const [dispositionHangupButton, setDispositionHangupButton] = useState('none');
    const [callType, setCallType] = useState('');
    const [callTypeCallLog, setCallTypeCallLog] = useState('');
    const [dispositionContact, setDispositionContact] = useState('');
    // Isolated copies used ONLY while the disposition modal is open so a new
    // incoming/outgoing call cannot change the form the agent is filling in.
    const [modalDispositionContact, setModalDispositionContact] = useState('');
    const [modalCallType, setModalCallType] = useState('');
    const [callLogDuration, setCallLogDuration] = useState('');

    const [activeTransferButton, setActiveTransferButton] = useState(null);

    // Auto Dialer States
    const [campaignMode, setCampaignMode] = useState(false);
    const [campaignContacts, setCampaignContacts] = useState([]);
    const [currentContactIndex, setCurrentContactIndex] = useState(0);
    const [campaignTimeout, setCampaignTimeout] = useState(30);
    const campaignTimeoutRef = useRef(null);
    const [flashSwitch, setFlashSwitch] = useState(false);
    // Wrap-up countdown between campaign calls (seconds remaining; 0 = inactive)
    const [wrapUpSeconds, setWrapUpSeconds] = useState(0);
    const wrapUpIntervalRef = useRef(null);
    const wrapUpTimeoutRef = useRef(null);
    const WRAP_UP_SECONDS = 12;

    // State Management
    const [voipSignalStatus, setVoipSignalStatus] = useState('#FF160C');
    const [registered, setRegistered] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [isHeld, setIsHeld] = useState(false);
    const [connectionStatus, setConnectionStatus] = useState('disconnected');
    const userAgentRef = useRef(null);
    const registererRef = useRef(null);
    const registrationTimeoutRef = useRef(null);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const connectivityCheckIntervalRef = useRef(null);
    const statusCheckIntervalRef = useRef(null);
    const [acceptCallHandler, setAcceptCallHandler] = useState(null);
    const [rejectCallHandler, setRejectCallHandler] = useState(null);
    const [openTakingBreakModal, setTakingBreakOpen] = useState(false);
    const [dispositionCategory, setDispositionCategory] = useState([]);
    const [subCategorDataDropDown, setSubCategorDataDropDown] = useState([]);

    const remoteAudioRef = useRef(null);
    const localAudioRef = useRef(null);
    const dialedNumberRef = useRef(null);

    const [callEnabled, setCallEnabled] = useState(true);
    const [takeBreak, setTakeBreak] = useState(false);
    const [autoAnswer, setAutoAnswer] = useState(false);
    const [isRingtoneMuted, setIsRingtoneMuted] = useState(false);
    const [RingtoneIcon, setRingtoneIcon] = useState(true);

    const callEnabledRef = useRef(callEnabled);
    const takeBreakRef = useRef(takeBreak);
    const autoAnswerRef = useRef(autoAnswer);

    const incomingCallSessionRef = useRef(null);
    const outgoingCallSessionRef = useRef(null);
    const activeCallSessionRef = useRef(null);
    const recording_call_id = useRef(null);
    const [breakType, setBreakType] = useState('');
    const [breakDrop, setBreakDrop] = useState('');
    const [breakBtn, setBreakBtn] = useState('none');

    const outgoingToneRef = useRef(new Audio('/Tones/dial_call.mp3'));
    const endcallToneRef = useRef(new Audio('/Tones/end_call.mp3'));
    const incomingRingtoneRef = useRef(new Audio('/Tones/ringtone_2.mp3'));
    const socketRef = useRef(null);

    // ONLINE PRESENCE
    const { socket, user_id } = useContext(WebSocketContext);
    const [onlineUsers, setOnlineUsers] = useState(new Set());

    // AudioContext stored in ref so it can be closed on cleanup
    const audioCtxRef = useRef(null);
    // mediaRecorder and recordedChunks in refs
    const mediaRecorderRef = useRef(null);
    const recordedChunksRef = useRef([]);

    // [RECORD] The mixer destination + context for the SAVE recorder. Kept in
    // refs so the conference merge can splice party2's audio into the same
    // recording graph without rebuilding the recorder.
    const recordCtxRef = useRef(null);
    const recordRemotePannerRef = useRef(null); // party1 (right channel) sink node
    const confRecordSourceRef = useRef(null);   // party2 source node, added on merge

    // [AUDIO] Dedicated audio socket ref — separate from signaling socket
    const audioSocketRef = useRef(null);
    // [AUDIO] Live stream recorder ref (separate from save recorder)
    const streamRecorderRef = useRef(null);
    // [AUDIO] Source stream for the live relay — kept so the relay recorder can
    // be RESTARTED mid-call when a supervisor joins the listen room. A restart
    // produces a fresh WebM header + timeline, which is what makes 2nd/3rd/nth
    // listen sessions work.
    const liveStreamDestRef = useRef(null);

    // [AUDIO] Session token to prevent stale chunks from an old recorder
    const liveRelaySessionRef = useRef(null);

    // Whisper chunk buffering refs
    const whisperChunkBufferRef = useRef([]);
    const whisperMetadataRef = useRef(null);
    const whisperDecodeTimeoutRef = useRef(null);
    const whisperAudioCtxRef = useRef(null);
    const whisperGainNodeRef = useRef(null);

    // Whisper MSE streaming refs (production-ready)
    const whisperMediaSourceRef = useRef(null);
    const whisperSourceBufferRef = useRef(null);
    const whisperAudioElementRef = useRef(null);
    const whisperChunkQueueRef = useRef([]);
    const whisperMseReadyRef = useRef(false);
    const whisperMimeTypeRef = useRef('audio/webm; codecs=opus');

    // ── ICE connection recovery ───────────────────────────────────────────────
    const iceRecoveryTimerRef = useRef(null);

    const drawerWidth = 240;
    const openRight = true;
    const theme = useTheme();

    const campaignModeRef = useRef(false);
    const campaignContactsRef = useRef([]);
    const currentContactIndexRef = useRef(0);
    // Hard latch: set true the moment the list is exhausted so any late/racing
    // end-event (duplicate Terminated + onReject, a stale no-answer timeout, etc.)
    // can't re-enter dialNextContact and re-dial the final contact.
    const campaignDoneRef = useRef(false);

    // ── Per-call log/advance guard ────────────────────────────────────────────
    const callLoggedRef = useRef({ done: true, advanced: true });
    const incomingCallLoggedRef = useRef(false);

    // Timestamp when an incoming invite started ringing — used to distinguish
    // a real Missed call from a short "flash" (caller rings briefly then hangs up).
    const incomingRingStartedAtRef = useRef(null);
    // Calls that ring for less than this many ms before ending are logged as Flashed.
    const FLASH_THRESHOLD_MS = 4000;

    // ── Simultaneous-answer race (call answered elsewhere) ─────────────────────
    // Set when CANCEL / Terminated / Failed arrives before this agent truly owns
    // the call (Established). Blocks a late accept() resolution from starting the
    // timer / accepted UI, and forces Missed/Flashed instead of a duration log.
    const callTakenElsewhereRef = useRef(false);
    // True only after SessionState.Established for the current incoming invite.
    const incomingEstablishedRef = useRef(false);
    // Generation token so a stale accept() for an old invite cannot resurrect UI.
    const incomingAcceptGenRef = useRef(0);
    // Ringing-phase terminal listener — stored so a genuine answer can detach it
    // before Established handlers take over (avoids Missed log on real hangup).
    const ringingTerminatedRef = useRef(null);
    // Watchdog: if accept() resolves but Established never arrives (CANCEL stuck,
    // half-answered race, dead ICE), force bail after this many ms.
    const acceptWatchdogRef = useRef(null);
    const ACCEPT_ESTABLISH_TIMEOUT_MS = 6000;
    // Simultaneous-answer ownership grace: after Established, wait this long
    // (or until remote media is ready) before claiming the call (timer + Picked).
    // If CANCEL/BYE arrives inside the window the agent lost the race → drop, no count.
    const incomingEstablishedAtRef = useRef(null);
    const incomingMediaReadyRef = useRef(false);
    const ownershipConfirmTimerRef = useRef(null);
    const OWNERSHIP_GRACE_MS = 1800;

    // ── Outgoing call "was it ever picked up" guard ─────────────────────────────
    const callEstablishedRef = useRef(false);

    // ── Local vs remote hangup ─────────────────────────────────────────────────
    // Set true only when the agent initiates hang-up (hangUpCall / hangUpCallOutGoing /
    // dispositionHangUpCall). Checked in onBye / Terminated handlers so we can tell
    // whether the remote party or the local agent ended the call.
    const localHangupRef = useRef(false);

    // Guard disposition modal fields (contact + call type) against being
    // overwritten by a subsequent incoming/outgoing call while the modal is
    // still open and the agent has not submitted/closed it yet.
    const dispositionModalOpenRef = useRef(false);

    // Pending delayed timer reset — always clear before start/reset to avoid
    // stacked timeouts (double hangup / new call within 3s) causing mixed counts.
    const resetTimerTimeoutRef = useRef(null);

    // ── Tone helpers ──────────────────────────────────────────────────────────
    const stopIncomingTone = () => {
        incomingRingtoneRef.current.pause();
        incomingRingtoneRef.current.currentTime = 0;
    };
    const stopOutgoingTone = () => {
        outgoingToneRef.current.pause();
        outgoingToneRef.current.currentTime = 0;
    };
    const stopEndTone = () => {
        endcallToneRef.current.pause();
        endcallToneRef.current.currentTime = 0;
    };
    const playOutgoingTone = () => {
        outgoingToneRef.current.play();
        outgoingToneRef.current.loop = true;
    };
    const playEndTone = () => {
        stopIncomingTone();
        stopOutgoingTone();
        setTimeout(() => {
            if (endcallToneRef.current) {
                endcallToneRef.current.currentTime = 0;
                endcallToneRef.current.play().catch(error => {
                    console.log('Error playing end tone:', error);
                });
            }
        }, 50);
    };
    const playIncomingTone = () => {
        incomingRingtoneRef.current.play();
        incomingRingtoneRef.current.loop = true;
    };

    const handleCallEnableChange = (event) => {
        if (!activeCallSessionRef.current) {
            const newValue = event.target.checked;
            setCallEnabled(newValue);
            callEnabledRef.current = newValue;
            localStorage.setItem('callEnabled', JSON.stringify(newValue));
        }
    };

    // ── Signaling socket init ─────────────────────────────────────────────────
    useEffect(() => {
        const token = localStorage.getItem(authToken);
        socketRef.current = io(socket_base_url, {
            socketiopath,
            auth: { token },
            transports: ['websocket'],
        });
        return () => {
            socketRef.current.disconnect();
        };
    }, []);

    // ── Drain queued chunks into SourceBuffer ──────────────────────────────
    const drainWhisperQueue = useCallback(() => {
        const sb = whisperSourceBufferRef.current;
        if (!sb || sb.updating || whisperChunkQueueRef.current.length === 0 || !whisperMseReadyRef.current) {
            return;
        }

        // --- Low Latency: Prevent whisper buffer from growing too large ---
        try {
            if (sb.buffered.length > 0 && !sb.updating) {
                const audio = whisperAudioElementRef.current;
                const currentTime = audio?.currentTime || 0;
                const bufferedEnd = sb.buffered.end(sb.buffered.length - 1);
                // If we have more than 1.5 seconds of audio buffered, drop the old stuff
                if (bufferedEnd - currentTime > 1.5) {
                    sb.remove(0, bufferedEnd - 1.0);
                    return; // Wait for remove to finish before appending
                }
            }
        } catch (e) {}
        // --------------------------------------------------------------------

        try {
            const nextChunk = whisperChunkQueueRef.current.shift();
            if (nextChunk?.byteLength > 0) {
                sb.appendBuffer(nextChunk);
            }
        } catch (err) {
            console.warn('[Whisper] SourceBuffer append error:', err.name, err.message);
            if (err.name === 'QuotaExceededError') {
                console.warn('[Whisper] SourceBuffer quota exceeded - clearing queue');
                whisperChunkQueueRef.current = [];
            }
        }
    }, []);

    // ── Teardown whisper MSE pipeline ──────────────────────────────────────
    const teardownWhisperMSE = useCallback(() => {
        whisperMseReadyRef.current = false;
        whisperChunkQueueRef.current = [];

        const sb = whisperSourceBufferRef.current;
        if (sb) {
            try { if (sb.updating) sb.abort(); } catch (_) {}
            whisperSourceBufferRef.current = null;
        }

        const ms = whisperMediaSourceRef.current;
        if (ms) {
            try { if (ms.readyState === 'open') ms.endOfStream(); } catch (_) {}
            whisperMediaSourceRef.current = null;
        }

        const audio = whisperAudioElementRef.current;
        if (audio) {
            audio.pause();
            // FIX: capture the blob URL BEFORE clearing src, otherwise the
            // revoke check always sees an empty string and the URL leaks.
            const oldSrc = audio.src;
            audio.src = '';
            try { if (oldSrc?.startsWith('blob:')) URL.revokeObjectURL(oldSrc); } catch (_) {}
            whisperAudioElementRef.current = null;
        }
        console.log('[Whisper] MSE pipeline torn down');
    }, []);

    // ── [AUDIO] Start (or RESTART) the live relay recorder ─────────────────
    // Called when a call starts AND whenever the relay server sends
    // REQUEST_CHUNK_RESEND (i.e. a supervisor joined the listen room). Each
    // (re)start creates a brand-new MediaRecorder on the same mixed stream,
    // which emits a fresh WebM header and a timeline starting at 0 — exactly
    // what the supervisor's MSE pipeline needs to begin playback.
    const startLiveRelay = useCallback((callId) => {
        const stream = liveStreamDestRef.current;
        if (!callId || !stream || !audioSocketRef.current?.connected) {
            console.warn('[Audio] Cannot start live relay — stream:', !!stream,
                'socket:', audioSocketRef.current?.connected, 'callId:', callId);
            return;
        }

        // Stop any existing relay recorder first — a MediaRecorder cannot be
        // restarted after stop(), so a new instance is created each time.
        if (streamRecorderRef.current && streamRecorderRef.current.state !== 'inactive') {
            try { streamRecorderRef.current.stop(); } catch (e) {}
        }
        streamRecorderRef.current = null;

        // ✅ FIX: session token prevents stale chunks from old recorder
        const sessionToken = Date.now();
        liveRelaySessionRef.current = sessionToken;

        let selectedMimeType = 'audio/webm; codecs=opus';
        if (!MediaRecorder.isTypeSupported(selectedMimeType)) {
            console.warn('[Audio] MIME type not supported:', selectedMimeType);
            if (MediaRecorder.isTypeSupported('audio/webm')) {
                selectedMimeType = 'audio/webm';
                console.log('[Audio] Using fallback MIME: audio/webm');
            } else {
                console.error('[Audio] No supported MIME type for live relay');
                return;
            }
        }

        const liveRecorder = new MediaRecorder(stream, {
            mimeType: selectedMimeType,
            audioBitsPerSecond: 32000,
        });

        let headerSent = false;
        let chunkIndex = 0;

        liveRecorder.ondataavailable = async (e) => {
            // ✅ FIX: Drop chunks from a stale recorder session
            if (liveRelaySessionRef.current !== sessionToken) return;

            if (e.data.size < 10) return;
            try {
                const buf = await e.data.arrayBuffer();
                const isHeader = !headerSent;
                if (isHeader) headerSent = true;
                chunkIndex++;

                audioSocketRef.current?.emit('AUDIO_CHUNK', {
                    callId,
                    chunk: buf,
                    isHeader,
                    mimeType: selectedMimeType,
                    chunkIndex,
                });
            } catch (err) {
                console.error('[Dialbar] Error sending audio chunk:', err);
            }
        };

        liveRecorder.onerror = (e) => console.error('[Audio] Live recorder error:', e.error);
        liveRecorder.onstop = () => console.log('[Audio] Live relay recorder stopped for call:', callId);

        streamRecorderRef.current = liveRecorder;
        // 200ms chunks for low-latency streaming to the supervisor
        liveRecorder.start(200);
        console.log('[Audio] Live relay recorder started (200ms chunks) for call:', callId);
    }, []);

    // [AUDIO] Audio socket init — connects to dedicated audio relay server
    useEffect(() => {
        const token = localStorage.getItem(authToken);

        audioSocketRef.current = io(audio_socket_base_url, {
            path: audio_socket_path,
            auth: { token },
            transports: ['websocket'],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
        });

        audioSocketRef.current.on('connect', () => {
            console.log('[Audio] Connected to audio relay');
            // Only re-register if we actually have an active call session
            if (recording_call_id.current && activeCallSessionRef.current) {
                console.log('[Audio] Re-registering call on reconnect:', recording_call_id.current);
                audioSocketRef.current.emit('REGISTER_CALL', { callId: recording_call_id.current });
                // Restart relay so any listening supervisor gets a fresh stream
                if (liveStreamDestRef.current) {
                    startLiveRelay(recording_call_id.current);
                }
            }
        });

        audioSocketRef.current.on('disconnect', (reason) => {
            console.warn('[Audio] Disconnected from audio relay:', reason);
            teardownWhisperMSE();
        });

        // ── [AUDIO] Supervisor joined the listen room — restart the relay so
        // they receive a fresh WebM header + timeline. THIS is the fix for
        // "listen works the first time but not the second".
        audioSocketRef.current.on('REQUEST_CHUNK_RESEND', ({ callId }) => {
            console.log('[Audio] 🔄 Fresh stream requested by relay for call:', callId);
            console.log('[Audio] 📋 recording_call_id:', recording_call_id.current);
            console.log('[Audio] 📋 Stream available:', !!liveStreamDestRef.current);

            // ✅ FIX: trim both sides to prevent mismatch from SIP header whitespace
            if (String(callId).trim() === String(recording_call_id.current).trim() && liveStreamDestRef.current) {
                startLiveRelay(recording_call_id.current);
            } else {
                console.warn('[Audio] Resend requested for unknown/ended call:', callId, '— expected:', recording_call_id.current);
            }
        });

        // ── WHISPER CHUNK: MSE-based streaming receiver ─────────────────────
        audioSocketRef.current.on('WHISPER_CHUNK', async ({ chunk, isHeader, mimeType, chunkIndex }) => {
            try {
                if (!whisperAudioCtxRef.current) {
                    // Use interactive latency hint for lower delay
                    whisperAudioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)({ latencyHint: 'interactive' });
                }
                const ctx = whisperAudioCtxRef.current;
                if (ctx.state === 'suspended') await ctx.resume();

                const buf = chunk instanceof ArrayBuffer ? chunk :
                        ArrayBuffer.isView(chunk) ? chunk.buffer.slice(chunk.byteOffset, chunk.byteOffset + chunk.byteLength) :
                        new Uint8Array(Object.values(chunk)).buffer;

                if (isHeader) {
                    // Every whisper session starts with a header (the supervisor
                    // creates a new MediaRecorder per toggle) — tear down any
                    // previous pipeline and rebuild fresh. This makes the 2nd,
                    // 3rd, nth whisper work exactly like the first.
                    console.log('[Whisper] Header received - initializing MSE pipeline');
                    teardownWhisperMSE();

                    const mimeToUse = mimeType || 'audio/webm; codecs=opus';
                    if (!MediaSource.isTypeSupported(mimeToUse)) {
                        const fallbacks = ['audio/webm', 'audio/mp4; codecs=mp4a.40.2', 'audio/mp4'];
                        let found = false;
                        for (const fb of fallbacks) {
                            if (MediaSource.isTypeSupported(fb)) {
                                whisperMimeTypeRef.current = fb;
                                found = true;
                                break;
                            }
                        }
                        if (!found) return;
                    } else {
                        whisperMimeTypeRef.current = mimeToUse;
                    }

                    const ms = new MediaSource();
                    const audio = new Audio();
                    audio.autoplay = true;
                    audio.preload = 'auto';

                    whisperMediaSourceRef.current = ms;
                    whisperAudioElementRef.current = audio;

                    const onSourceOpen = () => {
                        try {
                            const mime = whisperMimeTypeRef.current;
                            const sb = ms.addSourceBuffer(mime);
                            whisperSourceBufferRef.current = sb;
                            sb.mode = 'segments';

                            if (!whisperGainNodeRef.current) {
                                whisperGainNodeRef.current = ctx.createGain();
                                whisperGainNodeRef.current.gain.value = 0.8;
                                whisperGainNodeRef.current.connect(ctx.destination);
                            }

                            try {
                                const srcNode = ctx.createMediaElementSource(audio);
                                srcNode.connect(whisperGainNodeRef.current);
                            } catch (e) {}

                            const playAudio = async () => {
                                try { await audio.play(); } catch (err) {}
                                document.removeEventListener('click', playAudio);
                                document.removeEventListener('touchstart', playAudio);
                            };
                            document.addEventListener('click', playAudio, { once: true, passive: true });
                            document.addEventListener('touchstart', playAudio, { once: true, passive: true });

                            if (buf.byteLength > 0) sb.appendBuffer(buf);
                            sb.addEventListener('updateend', drainWhisperQueue);
                            sb.addEventListener('error', (e) => {
                                whisperChunkQueueRef.current = [];
                            });

                            whisperMseReadyRef.current = true;
                        } catch (err) {
                            teardownWhisperMSE();
                        }
                    };

                    ms.addEventListener('sourceopen', onSourceOpen, { once: true });
                    audio.src = URL.createObjectURL(ms);
                    audio.play().catch(err => {});
                    return;
                }

                if (!whisperMseReadyRef.current || !whisperSourceBufferRef.current) {
                    whisperChunkQueueRef.current.push(buf);
                    return;
                }

                whisperChunkQueueRef.current.push(buf);
                drainWhisperQueue();

            } catch (err) {
                console.error('[Whisper] Error processing chunk:', err);
            }
        });

        audioSocketRef.current.on('WHISPER_RESYNC_REQUEST', ({ callId }) => {
            console.log('[Whisper] Resync requested for call:', callId);
        });

        return () => {
            audioSocketRef.current?.off('connect');
            audioSocketRef.current?.off('disconnect');
            audioSocketRef.current?.off('REQUEST_CHUNK_RESEND');
            audioSocketRef.current?.off('WHISPER_CHUNK');
            audioSocketRef.current?.off('WHISPER_RESYNC_REQUEST');

            teardownWhisperMSE();

            if (whisperAudioCtxRef.current?.state !== 'closed') {
                whisperAudioCtxRef.current?.close();
                whisperAudioCtxRef.current = null;
            }

            audioSocketRef.current?.disconnect();
        };
    }, [authToken, teardownWhisperMSE, drainWhisperQueue, startLiveRelay]);

    const handleTakeBreakChange = ({ target: { checked: newValue } }) => {
        if (activeCallSessionRef.current) return;
        setTakeBreak(newValue);
        takeBreakRef.current = newValue;
        setTakingBreakOpen(newValue);
        function randomBreakString(length = 10) {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        }
        sessionStorage.setItem('break', randomBreakString());
        if (newValue === false) {
            setAutoAnswer(false);
            autoAnswerRef.current = false;
            resetTime();
        } else {
            startTime();
        }
    };

    const handleAutoAnswerChange = (event) => {
        if (takeBreak) {
            setAutoAnswer(false);
            autoAnswerRef.current = false;
            return;
        }
        const newValue = event.target.checked;
        setAutoAnswer(newValue);
        autoAnswerRef.current = newValue;
    };

    // Keep refs in lockstep with mute/hold state for stale-free reads inside
    // async replaceTrack callbacks.
    useEffect(() => { isMutedRef.current = isMuted; }, [isMuted]);
    useEffect(() => { isHeldRef.current = isHeld; }, [isHeld]);

    useEffect(() => {
        const savedCallEnabledValue = localStorage.getItem('callEnabled');
        if (savedCallEnabledValue !== null) {
            const initialValue = JSON.parse(savedCallEnabledValue);
            setCallEnabled(initialValue);
            callEnabledRef.current = initialValue;
        }
    }, []);

    // Shaking Incoming Call Icon
    const ShakingRingVolumeIcon = styled(RingVolume)`
        animation: shake 0.9s linear infinite;
        transform-origin: center;
        @keyframes shake {
            0%   { transform: rotate(0deg); }
            10%  { transform: rotate(20deg); }
            20%  { transform: rotate(-20deg); }
            30%  { transform: rotate(10deg); }
            40%  { transform: rotate(-10deg); }
            50%  { transform: rotate(5deg); }
            60%  { transform: rotate(-5deg); }
            70%  { transform: rotate(2.5deg); }
            80%  { transform: rotate(-2.5deg); }
            90%  { transform: rotate(1deg); }
            100% { transform: rotate(0deg); }
        }
    `;

    const toggleTransferSelection = () => {
        const transferSelectionState = !transferSelection;
        setTransferSelection(transferSelectionState);
        setTransferCalls(false);
        resetTransferSelection();
        setTransferSelectionValue('');
        setExternalDisplay('');
    };

    const handleGetTransferToUsers = async () => {
        const transferCallState = !transferCalls;
        if (transferCallState) {
            try {
                const authyToken = localStorage.getItem(authToken);
                const response = await api.get('/user/usersfortransfer', {
                    headers: { Authorization: `Bearer ${authyToken}` },
                });
                setTransferToUsers(response.data.data);
            } catch (error) {
                console.error('Error fetching Disposition Group:', error);
            }
        }
    };

    const handleButtonDelete = () => {
        setDialDisplay(dialdisplay.slice(0, -1));
    };

    const handleDialButtonClick = (num) => {
        setDialDisplay(dialdisplay + num);
    };

    useEffect(() => {
        const handleDailerTabChange = (event) => {
            setSelectedDailerTab(event.detail);
        };
        window.addEventListener('dialerTabChange', handleDailerTabChange);
        return () => window.removeEventListener('dialerTabChange', handleDailerTabChange);
    }, []);

    useEffect(() => {
        const handleCampaignModeChange = () => {
            setSelectedDailerTab(3);
            setFlashSwitch(true);
            const timer = setTimeout(() => setFlashSwitch(false), 300);
            return () => clearTimeout(timer);
        };
        window.addEventListener('campaignMode', handleCampaignModeChange);
        return () => window.removeEventListener('campaignMode', handleCampaignModeChange);
    }, []);

    const clearPendingTimerReset = () => {
        if (resetTimerTimeoutRef.current) {
            clearTimeout(resetTimerTimeoutRef.current);
            resetTimerTimeoutRef.current = null;
        }
    };

    const startTime = () => {
        // Cancel any hangup/break delayed reset so a new call isn't zeroed mid-count
        clearPendingTimerReset();
        startTimer();
    };

    // Immediate reset — the old 3s delay caused the counter to keep running after
    // hangup and race with the next call (mixed / jumping duration).
    const resetTime = () => {
        clearPendingTimerReset();
        resetTimer();
    };

    const resetTimeIncoming = () => {
        clearPendingTimerReset();
        resetTimer();
    };

    // ── Safe duration helper ──────────────────────────────────────────────────
    const getSafeDuration = () => {
        const raw = getCurrentTimer();
        if (!raw || raw === '00:00:00') return '00:00:01';
        return raw;
    };

    // Classify an unanswered incoming as Flashed (very short ring) vs Missed.
    // Threshold is configurable via FLASH_THRESHOLD_MS (default 4s).
    const getMissedOrFlashed = () => {
        const started = incomingRingStartedAtRef.current;
        if (!started) return 'Missed';
        const elapsed = Date.now() - started;
        return elapsed < FLASH_THRESHOLD_MS ? 'Flashed' : 'Missed';
    };

    const handleTransferChange = (event) => {
        if (unattendedInternalStatus) {
            setTransferExtension(event.target.value);
            forwardCall(event.target.value);
        } else {
            setTransferExtension(event.target.value);
            forwardAttendedExternalCall(event.target.value);
        }
    };

    // ── Media Elements Helper ─────────────────────────────────────────────────
    const setupMediaElements = () => {
        let remoteAudio = document.getElementById('remote-audio');
        let localAudio = document.getElementById('local-audio');
        if (!remoteAudio) {
            remoteAudio = document.createElement('audio');
            remoteAudio.id = 'remote-audio';
            remoteAudio.autoPlay = true;
            document.body.appendChild(remoteAudio);
        }
        if (!localAudio) {
            localAudio = document.createElement('audio');
            localAudio.id = 'local-audio';
            localAudio.autoPlay = true;
            localAudio.muted = true;
            document.body.appendChild(localAudio);
        }
        // Private audio for the conference third party. While the parent call is
        // held, the agent hears the third party through THIS element. After merge
        // it REMAINS the agent's only path to hear party2 — remote-audio still
        // carries only party1, and parentMix is an OUTBOUND sender track that is
        // never played locally. So this element stays unmuted for the duration of
        // the conference (see joinConferenceCall).
        let conferenceAudio = document.getElementById('conference-audio');
        if (!conferenceAudio) {
            conferenceAudio = document.createElement('audio');
            conferenceAudio.id = 'conference-audio';
            conferenceAudio.autoPlay = true;
            document.body.appendChild(conferenceAudio);
        }
        return { remoteAudio, localAudio, conferenceAudio };
    };

    // ── Internet Connectivity Handlers ────────────────────────────────────────
    useEffect(() => {
        const handleOnline = () => {
            console.log('Internet connection restored');
            setIsOnline(true);
            setTimeout(checkRegistrationStatus, 2000);
        };
        const handleOffline = () => {
            console.log('Internet connection lost');
            setIsOnline(false);
            setVoipSignalStatus('#888888');
            setConnectionStatus('offline');
            activeCallSessionRef.current = null;
        };
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        checkInternetConnectivity();
        connectivityCheckIntervalRef.current = setInterval(checkInternetConnectivity, 10000);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            if (connectivityCheckIntervalRef.current) clearInterval(connectivityCheckIntervalRef.current);
        };
    }, []);

    const checkInternetConnectivity = async () => {
        try {
            await fetch('https://www.google.com/favicon.ico', { mode: 'no-cors' });
            if (!isOnline) setIsOnline(true);
        } catch (error) {
            setIsOnline(false);
            setVoipSignalStatus('#888888');
            setConnectionStatus('offline');
        }
    };

    useEffect(() => {
        if (userAgentRef.current && isOnline) {
            statusCheckIntervalRef.current = setInterval(() => {
                checkRegistrationStatus();
            }, 30000);
        }
        return () => {
            if (statusCheckIntervalRef.current) clearInterval(statusCheckIntervalRef.current);
        };
    }, [userAgentRef.current, isOnline]);

    const checkRegistrationStatus = () => {
        if (!isOnline) {
            setVoipSignalStatus('#888888');
            setConnectionStatus('offline');
            return;
        }
        if (!userAgentRef.current) {
            setVoipSignalStatus('#FF160C');
            return;
        }
        const isConnected = userAgentRef.current.isConnected();
        if (!isConnected) {
            setVoipSignalStatus('#FF160C');
            setConnectionStatus('disconnected');
            try {
                userAgentRef.current.stop();
                handleDroppedCallUI();
                setupSIPClient();
                setTimeout(() => userAgentRef.current.start(), 1000);
            } catch (error) {
                console.error('Error restarting connection:', error);
            }
            return;
        }
        const isRegistered = registererRef.current
            ? registererRef.current.state === RegistererState.Registered
            : false;
        if (isRegistered) {
            setVoipSignalStatus('#39FF14');
            setRegistered(true);
            setConnectionStatus('connected');
        } else {
            setVoipSignalStatus('#FFFF00');
            setConnectionStatus('connecting');
            if (registrationTimeoutRef.current) clearTimeout(registrationTimeoutRef.current);
            registrationTimeoutRef.current = setTimeout(() => {
                if (!registered) setVoipSignalStatus('#FFA500');
            }, 5000);
            try {
                registererRef.current.register();
            } catch (error) {
                console.error('Error during registration:', error);
                setVoipSignalStatus('#FF160C');
                setConnectionStatus('failed');
            }
        }
    };

    const handleManualRegister = () => checkRegistrationStatus();

    useEffect(() => {
        setCallLogDuration(timer);
    }, [timer]);

    const handleIncomingCallUI = () => {
        setSelectedDailerTab(0);
        setMakingCall(false);
        setDisplayInput(false);
        setDialerButtons(false);
        setShowIncomingCall(true);
        setAcceptedCall(false);
        playIncomingTone();
        stopEndTone();
        stopOutgoingTone();
        resetTimeIncoming();
    };

    const handleAcceptingCallUI = () => {
        setMakingCall(false);
        setDisplayInput(false);
        setDialerButtons(false);
        setShowIncomingCall(false);
        setAcceptedCall(true);
        startTime();
        stopEndTone();
        stopIncomingTone();
        stopOutgoingTone();
        setDispositionHangupButton('');
        setRingtoneIcon(true);
        // Call was answered — no longer a Missed/Flashed candidate.
        incomingRingStartedAtRef.current = null;
    };

    const clearAcceptWatchdog = () => {
        if (acceptWatchdogRef.current) {
            clearTimeout(acceptWatchdogRef.current);
            acceptWatchdogRef.current = null;
        }
    };

    const clearOwnershipConfirmTimer = () => {
        if (ownershipConfirmTimerRef.current) {
            clearTimeout(ownershipConfirmTimerRef.current);
            ownershipConfirmTimerRef.current = null;
        }
    };

    const resetIncomingRaceRefs = () => {
        callTakenElsewhereRef.current = false;
        incomingEstablishedRef.current = false;
        incomingEstablishedAtRef.current = null;
        incomingMediaReadyRef.current = false;
        clearAcceptWatchdog();
        clearOwnershipConfirmTimer();
    };

    const clearRingingTerminatedListener = (invitation) => {
        const listener = ringingTerminatedRef.current;
        if (listener && invitation?.stateChange) {
            try { invitation.stateChange.removeListener(listener); } catch (_) {}
        }
        ringingTerminatedRef.current = null;
    };

    const handleDroppedCallUI = () => {
        // Safety: clear local-hangup flag so a late remote event can't be misclassified
        localHangupRef.current = false;
        // Clear ring clock so a late log can't mis-classify the next call.
        incomingRingStartedAtRef.current = null;
        // Clear simultaneous-answer race flags so the next invite starts clean.
        resetIncomingRaceRefs();
        // Invalidate any accept() still in flight for this (now dropped) invite.
        incomingAcceptGenRef.current += 1;
        // Drop stored ringing listener (invitation may already be gone).
        ringingTerminatedRef.current = null;

        setMakingCall(false);
        setDisplayInput(true);
        setDialerButtons(true);
        setShowIncomingCall(false);
        setAcceptedCall(false);
        setShowConnecting('');
        handleContactName('');
        setHideCallButtonsAccept(true);
        cleanupMediaElements();
        cleanupMediaStreams();
        setIsMuted(false);
        setIsHeld(false);
        setDtmfButtons(false);
        setDTMFValue('');
        stopEndTone();
        stopIncomingTone();
        stopOutgoingTone();
        setTransferCalls(false);
        setExternalTransferCalls(false);
        setTransferSelection(false);
        setExternalDisplay('');
        setDispositionHangupButton('none');
        resetTime();
        endCall();
        setDialDisplay('');
        setExternalAttendedTransferCalls(false);
        setTransferExtension('');
        setIsRingtoneMuted(false);

        // ── MIC-RELEASE FIX ────────────────────────────────────────────────
        // Capture the parent peer-connection BEFORE we null the session refs.
        // After a conference, teardownConference() asynchronously restores the
        // pristine mic onto the parent sender — but nothing ever stops it, and
        // the normal detachMediaStreams path below is skipped once the refs are
        // null. So the getUserMedia device stays live and the mic indicator
        // stays lit. We grab the PC here, run teardown, then explicitly stop
        // every outgoing audio sender track on it (plus the stashed mic refs).
        const parentPcForCleanup =
            activeCallSessionRef.current?.sessionDescriptionHandler?.peerConnection ||
            incomingCallSessionRef.current?.sessionDescriptionHandler?.peerConnection ||
            outgoingCallSessionRef.current?.sessionDescriptionHandler?.peerConnection ||
            null;

        // Tear the conference down while the peer connections are STILL live —
        // teardownConference needs them to restore mic tracks and end the child
        // leg. Must run before the refs below are nulled. Idempotent, so it's a
        // no-op if there was no conference or it was already torn down.
        if (conferenceSessionRef.current || isConfJoined || conferencePanel) {
            confTeardownGuardRef.current = false;
            teardownConference();
        }

        // Now stop EVERY outgoing audio track on the parent PC — including the
        // pristine mic restored by teardownConference — so getUserMedia releases
        // the device and the mic indicator turns off on ANY hangup (local or
        // remote) after a conference.
        if (parentPcForCleanup) {
            try {
                parentPcForCleanup.getSenders().forEach(sender => {
                    if (sender.track && sender.track.kind === 'audio') {
                        try { sender.track.stop(); } catch (_) {}
                    }
                });
            } catch (_) {}
        }
        // Belt-and-braces: stop the stashed mic refs directly in case the async
        // restore hasn't reattached them to a sender yet.
        [parentMicTrackRef, confMicTrackRef].forEach(ref => {
            if (ref.current) {
                try { ref.current.stop(); } catch (_) {}
                ref.current = null;
            }
        });
        // ───────────────────────────────────────────────────────────────────

        [incomingCallSessionRef, outgoingCallSessionRef, activeCallSessionRef].forEach(ref => {
            if (ref.current) ref.current = null;
        });
        const currentSession =
            incomingCallSessionRef.current ||
            outgoingCallSessionRef.current ||
            activeCallSessionRef.current;
        if (currentSession) detachMediaStreams(currentSession);
        clearIceRecoveryTimer();
        stopRecording();

        // Clear recording_call_id ONLY after logging paths have already run
        // (duration log always fires before handleDroppedCallUI).
        recording_call_id.current = null;
    };

    const handleMakingCallUI = () => {
        setMakingCall(true);
        setDisplayInput(false);
        setDialerButtons(false);
        setShowIncomingCall(false);
        setAcceptedCall(false);
    };

    const cleanupMediaStreams = () => {
        const stopElTracks = (id) => {
            const el = document.getElementById(id);
            if (el && el.srcObject) {
                try {
                    el.srcObject.getTracks().forEach((track) => {
                        try { track.stop(); } catch (_) {}
                    });
                } catch (_) {}
                el.srcObject = null;
            }
        };
        stopElTracks('remote-audio');
        stopElTracks('local-audio');
        stopElTracks('conference-audio');

        // Stop senders/receivers on every live peer connection (incoming + outgoing).
        // Missing the outgoing PC left getUserMedia alive after hangup.
        const sessions = [
            incomingCallSessionRef.current,
            outgoingCallSessionRef.current,
            activeCallSessionRef.current,
            conferenceSessionRef.current,
        ];
        const seen = new Set();
        sessions.forEach((session) => {
            const pc = session?.sessionDescriptionHandler?.peerConnection;
            if (!pc || seen.has(pc)) return;
            seen.add(pc);
            try {
                pc.getSenders().forEach((sender) => {
                    if (sender.track) {
                        try { sender.track.stop(); } catch (_) {}
                    }
                });
                pc.getReceivers().forEach((receiver) => {
                    if (receiver.track) {
                        try { receiver.track.stop(); } catch (_) {}
                    }
                });
            } catch (_) {}
        });
    };

    const addToQueue = (invitation, reason) => {
        try {
            const fromHeader = invitation.request.from;
            const callerNumber = fromHeader.uri.user;
            const callId = invitation.request.getHeader('Call-ID');
            const queuePayload = {
                callId,
                callerNumber,
                callerName: '',
                queueName: sessionStorage.getItem('queue_name') || 'Default',
                joinTime: new Date().toISOString(),
                reason,
            };
            handleContactName(callerNumber).then?.(() => {
                if (contactName) queuePayload.callerName = contactName;
            }).catch(() => { });
            socketRef.current?.emit('QUEUE_CALLER_ADD', queuePayload);
        } catch (e) {
            console.error('[Queue] Failed to emit QUEUE_CALLER_ADD:', e);
        }
    };

    const handleIncomingCall = (invitation) => {
        if (!callEnabledRef.current) {
            try { invitation.reject({ statusCode: 486 }); } catch (e) { console.error(e); }
            addToQueue(invitation, 'disabled');
            return;
        }
        // Busy if ANY leg is live — not only activeCallSessionRef.
        // outgoingCallSessionRef is set before invite().then assigns activeCallSessionRef,
        // so a second INVITE in that window used to ring through. Same for conference child.
        const isBusy =
            !!activeCallSessionRef.current ||
            !!outgoingCallSessionRef.current ||
            !!incomingCallSessionRef.current ||
            !!conferenceSessionRef.current;
        if (isBusy) {
            try { invitation.reject({ statusCode: 486 }); } catch (e) { console.error(e); }
            addToQueue(invitation, 'busy');
            return;
        }
        if (takeBreakRef.current) {
            try { invitation.reject({ statusCode: 486 }); } catch (e) { console.error(e); }
            addToQueue(invitation, 'break');
            return;
        }

        // Reset once-guard for this ringing invite so Missed / Rejected / duration share one log.
        incomingCallLoggedRef.current = false;
        localHangupRef.current = false;
        resetIncomingRaceRefs();
        clearRingingTerminatedListener(incomingCallSessionRef.current);
        // Bump generation so any in-flight accept() from a prior invite is ignored.
        incomingAcceptGenRef.current += 1;
        incomingRingStartedAtRef.current = Date.now(); // start ring clock for Missed vs Flashed
        incomingCallSessionRef.current = invitation;
        activeCallSessionRef.current = invitation;
        const fromHeader = activeCallSessionRef.current.request.from;
        const callerNumber = fromHeader.uri.user;
        recording_call_id.current = activeCallSessionRef.current.request.getHeader('Call-ID');
        setIncomingNumber(callerNumber);
        setDialerNumber(callerNumber);
        handleContactName(callerNumber);
        // Do not overwrite disposition contact while the modal is still open
        // for the previous call (agent may still be filling the form).
        if (!dispositionModalOpenRef.current) {
            setDispositionContact(callerNumber);
        }
        handleIncomingCallUI();
        setupMediaElements();
        showCallNotification(callerNumber);

        // ── Early stateChange listener while still ringing ──────────────────────
        // When another agent answers, the PBX sends CANCEL → Terminated.
        // Stored in ringingTerminatedRef so a genuine answer can detach it before
        // Established handlers take over (avoids logging Missed on real hangup).
        const ringingTerminated = (state) => {
            if (state !== SessionState.Terminated && state !== SessionState.Failed) return;
            try { invitation.stateChange.removeListener(ringingTerminated); } catch (_) {}
            if (ringingTerminatedRef.current === ringingTerminated) {
                ringingTerminatedRef.current = null;
            }

            // Mark answered-elsewhere BEFORE any async accept() can resume.
            callTakenElsewhereRef.current = true;
            incomingAcceptGenRef.current += 1;
            clearAcceptWatchdog();

            // Only treat as Missed/Flashed if we never reached Established.
            if (!incomingEstablishedRef.current) {
                if (!incomingCallLoggedRef.current) {
                    incomingCallLoggedRef.current = true;
                    const caller =
                        invitation.request?.from?.uri?.user ||
                        activeCallSessionRef.current?.request?.from?.uri?.user ||
                        '';
                    handleAddCallLog(
                        getMissedOrFlashed(),
                        'incoming',
                        sessionStorage.getItem('extension'),
                        caller,
                        'remote' // cancelled by network / other agent
                    );
                }
                resetTimer();
                handleDroppedCallUI();
            }
        };
        ringingTerminatedRef.current = ringingTerminated;
        invitation.stateChange.addListener(ringingTerminated);

        if (autoAnswerRef.current) {
            acceptIncomingCall(activeCallSessionRef.current);
            return;
        }

        activeCallSessionRef.current.delegate = {
            onBye: () => {
                if (!incomingEstablishedRef.current) {
                    callTakenElsewhereRef.current = true;
                    incomingAcceptGenRef.current += 1;
                    clearAcceptWatchdog();
                    if (!incomingCallLoggedRef.current) {
                        incomingCallLoggedRef.current = true;
                        const caller =
                            activeCallSessionRef.current?.request?.from?.uri?.user ||
                            invitation.request?.from?.uri?.user ||
                            '';
                        handleAddCallLog(
                            getMissedOrFlashed(),
                            'incoming',
                            sessionStorage.getItem('extension'),
                            caller,
                            'remote'
                        );
                    }
                    resetTimer();
                }
                handleDroppedCallUI();
            },
            onReject: () => {
                callTakenElsewhereRef.current = true;
                incomingAcceptGenRef.current += 1;
                clearAcceptWatchdog();
                if (!incomingEstablishedRef.current && !incomingCallLoggedRef.current) {
                    incomingCallLoggedRef.current = true;
                    const caller =
                        activeCallSessionRef.current?.request?.from?.uri?.user ||
                        invitation.request?.from?.uri?.user ||
                        '';
                    handleAddCallLog(
                        getMissedOrFlashed(),
                        'incoming',
                        sessionStorage.getItem('extension'),
                        caller,
                        'remote'
                    );
                }
                if (!incomingEstablishedRef.current) resetTimer();
                handleDroppedCallUI();
            },
            onCancel: () => {
                // CANCEL = another agent (or network) took / killed the invite.
                callTakenElsewhereRef.current = true;
                incomingAcceptGenRef.current += 1;
                clearAcceptWatchdog();
                if (!incomingEstablishedRef.current && !incomingCallLoggedRef.current) {
                    incomingCallLoggedRef.current = true;
                    const caller =
                        activeCallSessionRef.current?.request?.from?.uri?.user ||
                        incomingCallSessionRef.current?.request?.from?.uri?.user ||
                        '';
                    handleAddCallLog(
                        getMissedOrFlashed(),
                        'incoming',
                        sessionStorage.getItem('extension'),
                        caller,
                        'remote'
                    );
                }
                if (!incomingEstablishedRef.current) {
                    resetTimer();
                    handleDroppedCallUI();
                }
            },
        };
        setAcceptCallHandler(() => () => acceptIncomingCall(activeCallSessionRef.current));
        setRejectCallHandler(() => () => rejectIncomingCall(incomingCallSessionRef.current));
    };

    // ── Single exit when this agent never owns the call (answered elsewhere) ──
    const bailAnsweredElsewhere = (invitation, label = null) => {
        callTakenElsewhereRef.current = true;
        incomingAcceptGenRef.current += 1;
        clearAcceptWatchdog();
        clearOwnershipConfirmTimer();
        clearRingingTerminatedListener(invitation);
        // Treat as never-owned so we always log Missed/Flashed (not a duration).
        incomingEstablishedRef.current = false;
        incomingEstablishedAtRef.current = null;
        incomingMediaReadyRef.current = false;

        // Stop any mic tracks on this invite's PC immediately — accept() may
        // already have opened getUserMedia before CANCEL / race loss.
        try {
            const pc = invitation?.sessionDescriptionHandler?.peerConnection;
            if (pc) {
                pc.getSenders().forEach((sender) => {
                    if (sender.track && sender.track.kind === 'audio') {
                        try { sender.track.stop(); } catch (_) {}
                    }
                });
                pc.getReceivers().forEach((receiver) => {
                    if (receiver.track) {
                        try { receiver.track.stop(); } catch (_) {}
                    }
                });
            }
        } catch (_) {}

        // Best-effort release of a half-accepted leg so we don't hold the dialog.
        try {
            if (invitation && invitation.state !== SessionState.Terminated) {
                if (invitation.state === SessionState.Established) {
                    invitation.bye?.();
                } else {
                    // Prefer reject if still early; cancel/bye as fallback.
                    try {
                        invitation.reject?.({ statusCode: 487 });
                    } catch (_) {
                        try { invitation.cancel?.(); } catch (__) {
                            try { invitation.bye?.(); } catch (___) {}
                        }
                    }
                }
            }
        } catch (e) {
            console.warn('[Incoming] bailAnsweredElsewhere end error:', e);
        }

        if (!incomingCallLoggedRef.current) {
            incomingCallLoggedRef.current = true;
            const caller =
                invitation?.request?.from?.uri?.user ||
                activeCallSessionRef.current?.request?.from?.uri?.user ||
                '';
            handleAddCallLog(
                label || getMissedOrFlashed(),
                'incoming',
                sessionStorage.getItem('extension'),
                caller,
                'remote'
            );
        }
        resetTimer();
        handleDroppedCallUI();
        incomingCallSessionRef.current = null;
        if (activeCallSessionRef.current === invitation) {
            activeCallSessionRef.current = null;
        }
    };

    const acceptIncomingCall = async (invitation) => {
        if (!invitation) return;

        // Already dead or marked taken elsewhere before click.
        if (
            invitation.state === SessionState.Terminated ||
            invitation.state === SessionState.Failed ||
            callTakenElsewhereRef.current
        ) {
            bailAnsweredElsewhere(invitation);
            return;
        }

        const acceptGen = incomingAcceptGenRef.current;
        const callerNumber =
            invitation.request?.from?.uri?.user ||
            activeCallSessionRef.current?.request?.from?.uri?.user ||
            '';
        const extensionNumber = sessionStorage.getItem('extension');
        const acceptedRecordingId =
            recording_call_id.current ||
            invitation.request?.getHeader?.('Call-ID') ||
            null;

        // True only after we have run onEstablished once for this accept attempt.
        let establishedHandled = false;

        const logIncomingOnce = (disposition, disconnectDir = null) => {
            if (incomingCallLoggedRef.current) return;
            incomingCallLoggedRef.current = true;
            const dir = disconnectDir ?? (localHangupRef.current ? 'local' : 'remote');
            localHangupRef.current = false;
            handleAddCallLog(
                disposition,
                'incoming',
                extensionNumber,
                callerNumber,
                dir,
                acceptedRecordingId,
            );
        };

        const cleanupCall = () => {
            try {
                [incomingCallSessionRef, activeCallSessionRef].forEach(ref => {
                    ref.current?.stateChange?.removeAllListeners();
                    ref.current = null;
                });
            } catch (e) {
                console.warn('Cleanup error:', e);
            }
        };

        // True only after ownership is confirmed (grace elapsed / media ready).
        let ownershipConfirmed = false;

        // Winner-only path: start timer + log Picked. Losers never reach here.
        const confirmIncomingOwnership = () => {
            if (ownershipConfirmed) return;
            if (
                acceptGen !== incomingAcceptGenRef.current ||
                callTakenElsewhereRef.current
            ) {
                bailAnsweredElsewhere(invitation);
                return;
            }
            if (
                !invitation ||
                invitation.state === SessionState.Terminated ||
                invitation.state === SessionState.Failed
            ) {
                bailAnsweredElsewhere(invitation);
                return;
            }

            ownershipConfirmed = true;
            clearOwnershipConfirmTimer();

            // Reset log guard so hangup can later write the real duration.
            incomingCallLoggedRef.current = false;

            handleAcceptingCallUI(); // timer starts HERE (winner only)
            if (!dispositionModalOpenRef.current) {
                setCallType('incoming');
            }

            handleAddCallLog(
                'Picked',
                'incoming',
                extensionNumber,
                callerNumber,
                null,
                acceptedRecordingId,
            );
        };

        // Established seen — attach media, start grace timer. Do NOT claim yet.
        const onEstablished = () => {
            if (establishedHandled) return;
            if (
                acceptGen !== incomingAcceptGenRef.current ||
                callTakenElsewhereRef.current
            ) {
                bailAnsweredElsewhere(invitation);
                return;
            }
            if (
                invitation.state === SessionState.Terminated ||
                invitation.state === SessionState.Failed
            ) {
                bailAnsweredElsewhere(invitation);
                return;
            }

            establishedHandled = true;
            incomingEstablishedRef.current = true;
            incomingEstablishedAtRef.current = Date.now();
            incomingMediaReadyRef.current = false;
            clearAcceptWatchdog();
            // Detach ringing-phase terminal listener so a later hangup is not Missed.
            clearRingingTerminatedListener(invitation);

            // Attach media early so we can detect real remote audio, but do NOT
            // start the timer or log Picked until ownership is confirmed.
            attachMediaStreams(invitation);

            clearOwnershipConfirmTimer();
            ownershipConfirmTimerRef.current = setTimeout(() => {
                ownershipConfirmTimerRef.current = null;
                confirmIncomingOwnership();
            }, OWNERSHIP_GRACE_MS);
        };

        // Lost race after a brief Established (or never established).
        const dropAsRaceLoss = (label = null) => {
            clearOwnershipConfirmTimer();
            // Force never-owned so bail logs Missed/Flashed, not a duration.
            incomingEstablishedRef.current = false;
            bailAnsweredElsewhere(invitation, label || getMissedOrFlashed());
        };

        // Terminal before Established → never own the call.
        const onTerminalBeforeEstablished = (label = null) => {
            if (ownershipConfirmed) return false;
            if (incomingEstablishedRef.current || establishedHandled) {
                // Established but ownership not confirmed yet → simultaneous-answer loss.
                dropAsRaceLoss(label);
                return true;
            }
            bailAnsweredElsewhere(invitation, label);
            return true;
        };

        // Install terminal / Established watcher BEFORE accept() so CANCEL during
        // the accept round-trip cannot be missed.
        const acceptPhaseListener = (state) => {
            if (state === SessionState.Established) {
                onEstablished();
                return;
            }
            if (state === SessionState.Terminated || state === SessionState.Failed) {
                if (ownershipConfirmed) {
                    // Genuine answered call that later ended.
                    clearAcceptWatchdog();
                    clearOwnershipConfirmTimer();
                    try { invitation.stateChange.removeListener(acceptPhaseListener); } catch (_) {}
                    if (!incomingCallLoggedRef.current) {
                        logIncomingOnce(getSafeDuration());
                    }
                    cleanupCall();
                    handleDroppedCallUI();
                } else if (incomingEstablishedRef.current || establishedHandled) {
                    // Lost simultaneous-answer race (Established briefly, then CANCEL/BYE).
                    try { invitation.stateChange.removeListener(acceptPhaseListener); } catch (_) {}
                    dropAsRaceLoss();
                } else {
                    try { invitation.stateChange.removeListener(acceptPhaseListener); } catch (_) {}
                    onTerminalBeforeEstablished();
                }
            }
        };
        invitation.stateChange.addListener(acceptPhaseListener);

        invitation.delegate = {
            onCancel: () => {
                if (onTerminalBeforeEstablished('Canceled')) return;
                if (ownershipConfirmed) {
                    logIncomingOnce('Canceled', 'remote');
                    cleanupCall();
                    handleDroppedCallUI();
                } else {
                    dropAsRaceLoss('Canceled');
                }
            },
            onBye: () => {
                if (onTerminalBeforeEstablished()) return;
                if (ownershipConfirmed) {
                    logIncomingOnce(getSafeDuration());
                    cleanupCall();
                    handleDroppedCallUI();
                    playEndTone();
                } else {
                    dropAsRaceLoss();
                }
            },
            onReject: () => {
                if (onTerminalBeforeEstablished('Rejected')) return;
                if (ownershipConfirmed) {
                    logIncomingOnce('Rejected', 'remote');
                    cleanupCall();
                    handleDroppedCallUI();
                } else {
                    dropAsRaceLoss('Rejected');
                }
            },
        };

        try {
            stopIncomingTone();
            setShowConnecting('Connecting...');
            setRingtoneIcon(false);
            setHideCallButtonsAccept(false);

            // Watchdog: accept resolved but Established never arrives.
            clearAcceptWatchdog();
            acceptWatchdogRef.current = setTimeout(() => {
                acceptWatchdogRef.current = null;
                if (!incomingEstablishedRef.current && !establishedHandled) {
                    console.warn('[Incoming] Accept watchdog — Established never arrived');
                    bailAnsweredElsewhere(invitation);
                }
            }, ACCEPT_ESTABLISH_TIMEOUT_MS);

            await invitation.accept({
                sessionDescriptionHandlerOptions: {
                    constraints: SIP_AUDIO_CONSTRAINTS,
                },
            });

            // Post-accept re-check: race lost while accept() was in flight.
            if (
                acceptGen !== incomingAcceptGenRef.current ||
                callTakenElsewhereRef.current ||
                invitation.state === SessionState.Terminated ||
                invitation.state === SessionState.Failed
            ) {
                console.warn('[Incoming] Accept lost race — call answered elsewhere or terminated');
                onTerminalBeforeEstablished();
                return;
            }

            // If already Established by the time accept() resolved, run ownership path.
            if (invitation.state === SessionState.Established) {
                onEstablished();
            }
            // Otherwise wait for acceptPhaseListener / watchdog.
            // Do NOT start timer or log Picked here.
        } catch (error) {
            // Accept failed — almost always another agent answered (CANCEL / 487).
            console.error('Error accepting call:', error);
            onTerminalBeforeEstablished();
        }
    };

    const rejectIncomingCall = () => {
        const session = incomingCallSessionRef.current;
        if (!session) return;
        try {
            if (session.state !== SessionState.Terminated) session.reject();
        } catch (error) {
            console.error('Error rejecting call:', error);
        } finally {
            if (!incomingCallLoggedRef.current) {
                incomingCallLoggedRef.current = true;
                handleAddCallLog(
                    'Rejected',
                    'incoming',
                    sessionStorage.getItem('extension'),
                    session.request.from.uri.user
                );
            }
            incomingCallSessionRef.current = null;
            activeCallSessionRef.current = null;
            handleDroppedCallUI();
        }
    };

    // ── Clear wrap-up countdown timers/UI ─────────────────────────────────────
    const clearWrapUp = () => {
        if (wrapUpIntervalRef.current) {
            clearInterval(wrapUpIntervalRef.current);
            wrapUpIntervalRef.current = null;
        }
        if (wrapUpTimeoutRef.current) {
            clearTimeout(wrapUpTimeoutRef.current);
            wrapUpTimeoutRef.current = null;
        }
        setWrapUpSeconds(0);
    };

    // Skip remaining wrap-up and dial next contact immediately
    const skipWrapUp = () => {
        if (!wrapUpTimeoutRef.current) return;
        const pending = wrapUpTimeoutRef.current;
        clearWrapUp();
        if (typeof pending._onFire === 'function') {
            pending._onFire();
        }
    };

    // Start wrap-up countdown, then run onComplete after WRAP_UP_SECONDS
    const startWrapUp = (onComplete) => {
        clearWrapUp();
        setWrapUpSeconds(WRAP_UP_SECONDS);

        wrapUpIntervalRef.current = setInterval(() => {
            setWrapUpSeconds((prev) => {
                if (prev <= 1) {
                    clearInterval(wrapUpIntervalRef.current);
                    wrapUpIntervalRef.current = null;
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        const fire = () => {
            clearWrapUp();
            onComplete();
        };
        wrapUpTimeoutRef.current = setTimeout(fire, WRAP_UP_SECONDS * 1000);
        wrapUpTimeoutRef.current._onFire = fire;
    };

    // ── Campaign: advance exactly ONCE per dialed contact ────────────────────
    const advanceCampaignOnce = (guard) => {
        if (!campaignModeRef.current || campaignDoneRef.current) return;
        const g = guard || callLoggedRef.current;
        if (!g || g.advanced) return;
        g.advanced = true;

        // ✅ FIX A: Clear any pending per-contact timeout so it can't double-fire
        if (campaignTimeoutRef.current) {
            clearTimeout(campaignTimeoutRef.current);
            campaignTimeoutRef.current = null;
        }

        // Derive the next index from the index THIS guard was stamped with in
        // makeCall — not from the mutable currentContactIndexRef. This is the
        // core fix for the "last number repeats N times" bug: several end-events
        // for the same contact all carry the same stamped index, so they all
        // resolve to the same nextIndex, and once one has advanced (g.advanced)
        // the rest are no-ops. Falling back to the ref keeps manual/edge cases
        // working if a guard somehow arrived unstamped.
        const baseIndex = (g.contactIndex != null) ? g.contactIndex : currentContactIndexRef.current;
        const nextIndex = baseIndex + 1;

        // If we've reached the end, latch completion HERE so nothing else can
        // re-enter, then run the clean teardown via dialNextContact's end branch.
        if (nextIndex >= campaignContactsRef.current.length) {
            campaignDoneRef.current = true;
            startWrapUp(() => dialNextContact(campaignContactsRef.current, nextIndex));
            return;
        }

        currentContactIndexRef.current = nextIndex;
        setCurrentContactIndex(nextIndex);
        startWrapUp(() => dialNextContact(campaignContactsRef.current, nextIndex));
    };

    const hangUpCall = () => {
        localHangupRef.current = true; // agent initiated

        // Snapshot EVERYTHING before any bye() / Terminated handler can run.
        const snapshotExtension = sessionStorage.getItem('extension');
        const snapshotPeerNumber =
            dialedNumberRef.current ?? dialerNumber ?? incomingNumber ?? '';
        const snapshotWasEstablished = callEstablishedRef.current;
        const snapshotRecordingId = recording_call_id.current;
        const snapshotDuration = getSafeDuration();

        // Prefer live session refs over React state (callType can lag one render)
        const isOutgoing =
            callType === 'outgoing' || !!outgoingCallSessionRef.current;
        const isIncoming =
            callType === 'incoming' ||
            !!incomingCallSessionRef.current ||
            (!isOutgoing && !!activeCallSessionRef.current);

        // ── LOG FIRST (before bye) ──────────────────────────────────────────
        // Local hangup used to bye() first; session.stateChange Terminated then
        // called handleDroppedCallUI() with no log, clearing recording_call_id
        // and racing the duration POST. Logging while state is still intact
        // and passing recordingId explicitly fixes that.
        if (isOutgoing) {
            const guard = callLoggedRef.current;
            if (guard && !guard.done) {
                guard.done = true;
                const disposition = snapshotWasEstablished
                    ? snapshotDuration
                    : 'No Answer';
                handleAddCallLog(
                    disposition,
                    'outgoing',
                    snapshotPeerNumber,
                    snapshotExtension,
                    'local',
                    snapshotRecordingId,
                );
            }
        } else if (isIncoming) {
            if (!incomingCallLoggedRef.current) {
                incomingCallLoggedRef.current = true;
                // Match Picked insert: destination=extension, source=caller
                handleAddCallLog(
                    snapshotDuration,
                    'incoming',
                    snapshotExtension,
                    snapshotPeerNumber,
                    'local',
                    snapshotRecordingId,
                );
            }
        }

        // Drop the third party (and restore mic tracks) before ending the parent.
        if (conferenceSessionRef.current || isConfJoined || conferencePanel) {
            confTeardownGuardRef.current = false;
            teardownConference();
        }

        const endSession = (session) => {
            try {
                session?.state !== SessionState.Terminated && session?.bye();
            } catch (e) {
                console.warn('Error ending call:', e);
            }
        };
        try {
            // Only bye the active leg once (incoming and active often point at same session)
            const ended = new Set();
            [outgoingCallSessionRef, incomingCallSessionRef, activeCallSessionRef].forEach((ref) => {
                const s = ref.current;
                if (s && !ended.has(s)) {
                    ended.add(s);
                    endSession(s);
                }
                ref.current = null;
            });
        } finally {
            localHangupRef.current = false;
            handleDroppedCallUI();
            playEndTone();
            advanceCampaignOnce();
        }
    };

    const hangUpCallOutGoing = () => {
        localHangupRef.current = true; // agent initiated (early cancel)

        const guard = callLoggedRef.current;
        if (guard && !guard.done) {
            guard.done = true;
            handleAddCallLog(
                'No Answer',
                'outgoing',
                dialedNumberRef.current ?? dialerNumber,
                sessionStorage.getItem('extension'),
                'local'
            );
        }
        if (outgoingCallSessionRef.current) {
            try { outgoingCallSessionRef.current.cancel(); } catch (e) { console.warn('Cancel error:', e); }
            outgoingCallSessionRef.current = null;
        } else if (activeCallSessionRef.current) {
            try { activeCallSessionRef.current.cancel(); } catch (e) { console.warn('Cancel error:', e); }
            activeCallSessionRef.current = null;
        }
        localHangupRef.current = false;
        handleDroppedCallUI();

        // ✅ FIX C: ensure the campaign list keeps moving after a no-answer/manual hangup
        advanceCampaignOnce(guard);
    };

    const dispositionHangUpCall = () => {
        localHangupRef.current = true; // agent initiated

        // Snapshot + LOG before bye() (same race as hangUpCall)
        const snapshotExtension = sessionStorage.getItem('extension');
        const snapshotPeerNumber =
            dialedNumberRef.current ?? dialerNumber ?? incomingNumber ?? '';
        const snapshotRecordingId = recording_call_id.current;
        const snapshotDuration = getSafeDuration();
        const isIncoming =
            callType === 'incoming' ||
            callTypeCallLog === 'incoming' ||
            !!incomingCallSessionRef.current;
        const logType = isIncoming
            ? 'incoming'
            : (callType || callTypeCallLog || 'outgoing');

        const destination = isIncoming ? snapshotExtension : snapshotPeerNumber;
        const source = isIncoming ? snapshotPeerNumber : snapshotExtension;

        if (isIncoming) {
            if (!incomingCallLoggedRef.current) {
                incomingCallLoggedRef.current = true;
                handleAddCallLog(
                    snapshotDuration,
                    'incoming',
                    destination,
                    source,
                    'local',
                    snapshotRecordingId,
                );
            }
        } else {
            handleAddCallLog(
                snapshotDuration,
                logType,
                destination,
                source,
                'local',
                snapshotRecordingId,
            );
        }

        if (conferenceSessionRef.current || isConfJoined || conferencePanel) {
            confTeardownGuardRef.current = false;
            teardownConference();
        }
        const endSession = (session) => {
            try {
                if (session) {
                    session.state !== SessionState.Terminated
                        ? session.bye()
                        : session.cancel();
                }
            } catch (e) {
                console.warn('Error ending call:', e);
            }
        };
        try {
            const ended = new Set();
            [outgoingCallSessionRef, incomingCallSessionRef, activeCallSessionRef].forEach((ref) => {
                const s = ref.current;
                if (s && !ended.has(s)) {
                    ended.add(s);
                    endSession(s);
                }
                ref.current = null;
            });
        } finally {
            localHangupRef.current = false;
            handleDroppedCallUI();
            playEndTone();
        }
    };

    const cleanupMediaElements = () => {
        if (remoteAudioRef.current) {
            remoteAudioRef.current.srcObject = null;
            remoteAudioRef.current.remove();
            remoteAudioRef.current = null;
        }
        if (localAudioRef.current) {
            localAudioRef.current.srcObject = null;
            localAudioRef.current.remove();
            localAudioRef.current = null;
        }
    };

    // Unmount cleanup
    useEffect(() => {
        return () => {
            if (campaignTimeoutRef.current) clearTimeout(campaignTimeoutRef.current);
            clearWrapUp();
            clearIceRecoveryTimer();
            clearAcceptWatchdog();
            ringingTerminatedRef.current = null;
            audioCtxRef.current?.close();
            closeMixContexts();
            handleDroppedCallUI();
        };
    }, []);

    const setupSIPClient = async () => {
        const WsServer = sessionStorage.getItem('WsServer');
        const Extension = sessionStorage.getItem('Extension');
        const ExtPass = sessionStorage.getItem('ExtPass');
        const URI = sessionStorage.getItem('Uri');
        if (WsServer && Extension && ExtPass && URI) {
            const uri = UserAgent.makeURI(URI);
            if (!uri) { console.error('Failed to create target URI.'); return; }
            const userAgent = new UserAgent({
                uri,
                transportOptions: { wsServers: [WsServer], connectionTimeout: 10 },
                authorizationUsername: Extension,
                authorizationPassword: ExtPass,
                reconnectionAttempts: 5,
                reconnectionDelay: 5,
                sessionDescriptionHandlerFactoryOptions: {
                    iceCheckingTimeout: 10000,
                    rtcConfiguration: { iceServers: [{ urls: 'stun:stun.l.google.com:19302' }] },
                },
            });
            userAgentRef.current = userAgent;
            const registerer = new Registerer(userAgent);
            registererRef.current = registerer;
            userAgent.delegate = {
                onConnect: () => {
                    setConnectionStatus('connected');
                    setVoipSignalStatus('#FFFF00');
                    registerer.register();
                },
                onDisconnect: () => {
                    setRegistered(false);
                    setVoipSignalStatus('#888888');
                    setConnectionStatus('disconnected');
                },
                onInvite: (invitation) => handleIncomingCall(invitation),
            };
            registerer.stateChange.addListener((newState) => {
                switch (newState) {
                    case RegistererState.Registered:
                        setRegistered(true);
                        setVoipSignalStatus('#39FF14');
                        setConnectionStatus('connected');
                        break;
                    case RegistererState.Unregistered:
                        setRegistered(false);
                        setVoipSignalStatus('#FF160C');
                        setConnectionStatus('disconnected');
                        break;
                    case RegistererState.Terminated:
                        setRegistered(false);
                        setVoipSignalStatus('#888888');
                        setConnectionStatus('disconnected');
                        break;
                }
            });
            try {
                await userAgent.start();
            } catch (error) {
                console.error('Failed to start UserAgent:', error);
                setVoipSignalStatus('#FF160C');
                setConnectionStatus('disconnected');
            }
        } else {
            console.warn('SIP client setup skipped - missing configuration data');
        }
    };

    const makeCall = (phoneNumberParam) => {
        if (!userAgentRef.current || !registered) {
            console.error('Cannot make call - not registered or userAgent not initialized');
            return;
        }
        // Precedence FIX: an explicitly-passed number (campaign auto-dialer or any
        // programmatic dial) must win over the dialdisplay text-field state.
        // dialdisplay is React state and lags a render behind the setDialDisplay()
        // that dialNextContact fires right before calling makeCall — so reading it
        // first made every campaign contact after the first re-dial the STALE last
        // number (the value left in dialdisplay when the previous cycle ended).
        // The manual dial button calls makeCall() with no argument, so it still
        // falls back to dialdisplay as before.
        const numberToUse =
            (typeof phoneNumberParam === 'string' && phoneNumberParam.trim() !== '')
                ? phoneNumberParam
                : dialdisplay;
        if (numberToUse) {
            let dialednumber;
            if (numberToUse.length > 4) {
                const DialNumber = numberToUse.replace(/\s/g, '');
                const cleanedNumber = DialNumber.replace(/\D/g, '');
                if (/^0\d{9}$/.test(cleanedNumber)) {
                    dialednumber = `254${cleanedNumber.substring(1)}`;
                } else if (/^254\d{9}$/.test(cleanedNumber)) {
                    dialednumber = cleanedNumber;
                } else if (/^256\d{9}$/.test(cleanedNumber)) {
                    dialednumber = cleanedNumber;
                } else if (/^\+\d+$/.test(DialNumber)) {
                    dialednumber = DialNumber;
                } else {
                    dialednumber = DialNumber;
                }
            } else {
                dialednumber = numberToUse.replace(/\s/g, '');
            }
            handleMakingCallUI();
            setDialerNumber(dialednumber);
            handleContactName(dialednumber);
            // Do not overwrite disposition contact while the modal is still open
            // for the previous call (agent may still be filling the form).
            if (!dispositionModalOpenRef.current) {
                setDispositionContact(dialednumber);
            }
            dialedNumberRef.current = dialednumber;
            // Stamp the guard with the contact index it belongs to (campaign only).
            // advanceCampaignOnce derives the NEXT index from this stamp instead of
            // the mutable currentContactIndexRef, so racing end-events for the same
            // contact all compute the same next index and can't re-dial the last one.
            const thisCallGuard = {
                done: false,
                advanced: false,
                contactIndex: campaignModeRef.current ? currentContactIndexRef.current : null,
            };
            callLoggedRef.current = thisCallGuard;
            callEstablishedRef.current = false;
            localHangupRef.current = false;
            const Server_Url = sessionStorage.getItem('Server_Url');
            const targetURI = `sip:${dialednumber}@${Server_Url}`;
            const target = UserAgent.makeURI(targetURI);
            if (!target) { console.error('Invalid destination URI'); return; }
            setupMediaElements();
            const inviter = new Inviter(userAgentRef.current, target);
            // Set both refs immediately so a concurrent INVITE is treated as busy
            // before invite().then runs (that was the window where second calls rang through).
            outgoingCallSessionRef.current = inviter;
            activeCallSessionRef.current = inviter;
            const logCallOnce = (disposition, disconnectDir = null) => {
                if (thisCallGuard.done) return;
                thisCallGuard.done = true;
                const dir = disconnectDir ?? (localHangupRef.current ? 'local' : 'remote');
                localHangupRef.current = false;
                handleAddCallLog(disposition, 'outgoing', dialednumber, sessionStorage.getItem('extension'), dir);
            };
            inviter.invite({
                sessionDescriptionHandlerOptions: {
                    constraints: SIP_AUDIO_CONSTRAINTS,
                },
            }).then(() => {
                activeCallSessionRef.current = inviter;
                outgoingCallSessionRef.current = inviter;
                recording_call_id.current = activeCallSessionRef.current.request.getHeader('Call-ID');
                playOutgoingTone();
                inviter.delegate = {
                    onBye: () => {
                        // onBye = remote hangup unless we just set localHangupRef
                        const currentTime = getSafeDuration();
                        logCallOnce(currentTime);
                        handleDroppedCallUI();
                        playEndTone();
                        advanceCampaignOnce(thisCallGuard);
                    },
                };
                if (inviter && typeof inviter.stateChange !== 'undefined' && inviter.stateChange) {
                    inviter.stateChange.addListener((state) => {
                        if (state === SessionState.Established) {
                            callEstablishedRef.current = true;
                            attachMediaStreams(inviter);
                            handleAcceptingCallUI();
                            setDialerNumber(dialednumber);
                            // Preserve call type while disposition modal is open for prior call.
                            if (!dispositionModalOpenRef.current) {
                                setCallType('outgoing');
                            }
                            startCallOutGoing();
                        }
                        if (state === SessionState.Terminated) {
                            inviter.stateChange.removeAllListeners();
                            const disposition = callEstablishedRef.current
                                ? getSafeDuration()
                                : 'No Answer';
                            logCallOnce(disposition);
                            handleDroppedCallUI();
                            setDialDisplay(dialednumber);
                            playEndTone();
                            detachMediaStreams(inviter);
                            advanceCampaignOnce(thisCallGuard);
                        } else if (state === SessionState.Failed) {
                            logCallOnce('Failed', 'remote');
                            handleDroppedCallUI();
                            setDialDisplay(dialednumber);
                            playEndTone();
                            advanceCampaignOnce(thisCallGuard);
                        }
                    });
                } else {
                    setTimeout(() => attachMediaStreams(inviter), 1000);
                }
                outgoingCallSessionRef.current.onReject = (response) => {
                    const statusCode = response.message.statusCode;
                    let call_dispose = 'Failed';
                    if (statusCode === 486) call_dispose = 'Busy';
                    else if (statusCode === 480) call_dispose = 'No Answer';
                    else if (statusCode === 404) call_dispose = 'Invalid Number';
                    else if (statusCode === 403) call_dispose = 'Forbidden';
                    else if (statusCode === 408) call_dispose = 'Timeout';
                    logCallOnce(call_dispose, 'remote');
                    detachMediaStreams(inviter);
                    handleDroppedCallUI();
                    advanceCampaignOnce(thisCallGuard);
                };
            }).catch(error => {
                logCallOnce('Failed', 'remote');
                handleDroppedCallUI();
                activeCallSessionRef.current = null;
                advanceCampaignOnce(thisCallGuard);
            });
        }
    };

    // ── ICE recovery helpers ─────────────────────────────────────────────────
    const clearIceRecoveryTimer = () => {
        if (iceRecoveryTimerRef.current) {
            clearTimeout(iceRecoveryTimerRef.current);
            iceRecoveryTimerRef.current = null;
        }
    };

    const attachMediaStreams = (session) => {
        // Guard: never attach (or retry) against a dead / foreign session.
        if (
            !session ||
            session.state === SessionState.Terminated ||
            session.state === SessionState.Failed ||
            callTakenElsewhereRef.current
        ) {
            console.warn('[Audio] attachMediaStreams skipped — session dead or taken elsewhere');
            return;
        }
        if (!session?.sessionDescriptionHandler?.peerConnection) {
            console.error('Session/peer connection not available');
            return;
        }
        const peerConnection = session.sessionDescriptionHandler.peerConnection;
        const { remoteAudio, localAudio } = setupMediaElements();
        try {
            const receivers = peerConnection.getReceivers();
            const audioReceivers = receivers.filter(r => r.track && r.track.kind === 'audio');
            if (audioReceivers.length > 0) {
                const stream = new MediaStream([audioReceivers[0].track]);
                remoteAudio.srcObject = stream;
                remoteAudio.play().catch(e => {
                    document.addEventListener('click', function playOnClick() {
                        remoteAudio.play();
                        document.removeEventListener('click', playOnClick);
                    });
                });
                // Remote audio present — mark media ready for simultaneous-answer race.
                incomingMediaReadyRef.current = true;
            }
            const senders = peerConnection.getSenders();
            const audioSenders = senders.filter(s => s.track && s.track.kind === 'audio');
            if (audioSenders.length > 0) {
                const stream = new MediaStream([audioSenders[0].track]);
                localAudio.srcObject = stream;
                localAudio.play().catch(e => console.error('Error playing local audio:', e));
            }
            const remoteTrack = audioReceivers[0]?.track;
            let localTrack = audioSenders[0]?.track;

            // Retry only while the session is still alive and still ours.
            if (remoteTrack && localTrack) {
                recordStereo(remoteTrack, localTrack);
            } else {
                console.warn('[Audio] Tracks not ready, retrying in 500ms...', {
                    hasRemote: !!remoteTrack, hasLocal: !!localTrack
                });
                setTimeout(() => {
                    if (
                        session.state === SessionState.Terminated ||
                        session.state === SessionState.Failed ||
                        callTakenElsewhereRef.current
                    ) {
                        return;
                    }
                    attachMediaStreams(session);
                }, 500);
            }

            // ── ICE connection state monitor ──────────────────────────────────
            peerConnection.oniceconnectionstatechange = () => {
                const state = peerConnection.iceConnectionState;
                console.log('[ICE] Connection state:', state);

                if (state === 'disconnected') {
                    clearIceRecoveryTimer();
                    iceRecoveryTimerRef.current = setTimeout(() => {
                        if (peerConnection.iceConnectionState !== 'connected' &&
                            peerConnection.iceConnectionState !== 'completed') {
                            console.warn('[ICE] Recovery timeout — forcing call cleanup');
                            handleDroppedCallUI();
                            playEndTone();
                        }
                    }, 6000);
                } else if (state === 'failed' || state === 'closed') {
                    // closed: some PBX/network teardowns never emit a clean SIP Terminated.
                    console.warn('[ICE] Connection', state, '— forcing call cleanup');
                    clearIceRecoveryTimer();
                    handleDroppedCallUI();
                    playEndTone();
                } else if (state === 'connected' || state === 'completed') {
                    clearIceRecoveryTimer();
                }
            };
        } catch (error) {
            console.error('Error attaching media streams:', error);
        }
    };

    const detachMediaStreams = (session) => {
        if (!session?.sessionDescriptionHandler?.peerConnection) return;
        const peerConnection = session.sessionDescriptionHandler.peerConnection;
        const senders = peerConnection.getSenders();
        if (senders && senders.length > 0) {
            senders.filter(s => s.track && s.track.kind === 'audio').forEach(s => s.track.stop());
        }
        const { remoteAudio, localAudio } = setupMediaElements();
        if (remoteAudio) remoteAudio.srcObject = null;
        if (localAudio) localAudio.srcObject = null;
    };

    // ══════════════════════════════════════════════════════════════════════════
    // CONFERENCE CALL (3-party, browser-mixed) — mirrors Browser-Phone's approach
    //
    // No FreeSWITCH conference bridge. Two independent SIP legs exist:
    //   • parent  = activeCallSessionRef (the original call)
    //   • child   = conferenceSessionRef (the agent <-> third party)
    // On merge, for EACH peer connection we build a MediaStreamDestination that
    // sums the agent's mic + the OTHER leg's remote voice, then replaceTrack()
    // that mixed track into the sender. No SDP renegotiation needed.
    //
    // AGENT MONITORING: after merge, remote-audio still plays only party1 and the
    // outbound mixes are never played locally, so the agent hears party2 solely
    // through the private conference-audio element — which is why it must stay
    // UNMUTED for the whole conference. (Earlier code muted it on merge, which
    // silenced party2 for the agent.)
    // ══════════════════════════════════════════════════════════════════════════

    // Sum a set of MediaStreamTracks into one mixed audio track via a fresh
    // AudioContext. The synthesized track is tagged IsMixedTrack so mute/hold
    // logic can skip it (disabling it would kill the whole mix). Returns null on
    // failure so callers can bail cleanly.
    const MixAudioStreams = (tracks) => {
        try {
            const ctx = new (window.AudioContext || window.webkitAudioContext)();
            if (ctx.state === 'suspended') ctx.resume().catch(() => {});
            mixCtxRefs.current.push(ctx);
            const dest = ctx.createMediaStreamDestination();
            tracks
                .filter(t => t && t.readyState === 'live')
                .forEach(t => {
                    const src = ctx.createMediaStreamSource(new MediaStream([t]));
                    src.connect(dest);
                });
            const mixedTrack = dest.stream.getAudioTracks()[0];
            if (mixedTrack) mixedTrack.IsMixedTrack = true;
            return mixedTrack;
        } catch (e) {
            console.error('[Conf] MixAudioStreams failed:', e);
            return null;
        }
    };

    // Close every mixer AudioContext created during a conference.
    const closeMixContexts = () => {
        mixCtxRefs.current.forEach(ctx => {
            try { if (ctx.state !== 'closed') ctx.close(); } catch (_) {}
        });
        mixCtxRefs.current = [];
    };

    // Pull the first live remote (received) audio track off a session's PC.
    const getRemoteTrack = (session) => {
        const pc = session?.sessionDescriptionHandler?.peerConnection;
        if (!pc) return null;
        const recv = pc.getReceivers().find(r => r.track && r.track.kind === 'audio');
        return recv?.track || null;
    };

    // Restore a peer connection's outgoing audio to its ORIGINAL (un-mixed) mic
    // track. Honours the CURRENT mute state via the ref (not stale closure).
    //
    // MIC-RELEASE FIX: clear savedTrackRef AFTER kicking off the restore (not
    // before) so a racing hangup can't lose the reference before we've stopped
    // it. Also stop the outgoing mixed (IsMixedTrack) track once it's replaced,
    // so its AudioContext source detaches and doesn't keep the graph alive.
    const restoreOriginalTrack = (pc, savedTrackRef) => {
        if (!pc || !savedTrackRef.current) return;
        const original = savedTrackRef.current;
        pc.getSenders().forEach((sender) => {
            if (sender.track && sender.track.kind === 'audio') {
                const outgoing = sender.track; // the mixed track we're replacing
                sender.replaceTrack(original)
                    .then(() => {
                        if (outgoing && outgoing.IsMixedTrack) {
                            try { outgoing.stop(); } catch (_) {}
                        }
                        if (sender.track) sender.track.enabled = !isMutedRef.current;
                    })
                    .catch(e => console.error('[Conf] restoreOriginalTrack failed:', e));
            }
        });
        savedTrackRef.current = null; // clear AFTER kicking off restore
    };

    // Splice party2's remote audio OUT of the save-recording graph (called on
    // conference teardown). Leaves party1 + agent recording intact.
    const detachConfFromRecording = () => {
        if (confRecordSourceRef.current) {
            try { confRecordSourceRef.current.disconnect(); } catch (_) {}
            confRecordSourceRef.current = null;
        }
    };

    // Full conference teardown. Idempotent via confTeardownGuardRef so repeated
    // end-events (child BYE + parent hangup, etc.) don't double-run. Restores mic
    // tracks, stops the child leg, closes mixers, resets UI. Does NOT touch the
    // parent session refs — the caller (or handleDroppedCallUI) owns those.
    const teardownConference = () => {
        if (confTeardownGuardRef.current) return;
        confTeardownGuardRef.current = true;

        try {
            const parentPc = activeCallSessionRef.current?.sessionDescriptionHandler?.peerConnection;
            const childSession = conferenceSessionRef.current;
            const childPc = childSession?.sessionDescriptionHandler?.peerConnection;

            // Restore raw mic on the parent leg (only meaningful if we swapped it).
            if (parentPc) restoreOriginalTrack(parentPc, parentMicTrackRef);

            // Remove party2 from the save recording graph.
            detachConfFromRecording();

            // End the child leg. Stop its mic first so the device is released.
            if (childPc) {
                childPc.getSenders().forEach(s => {
                    // stop the child's ORIGINAL mic; the mixed track is ephemeral
                    if (s.track && !s.track.IsMixedTrack) { try { s.track.stop(); } catch (_) {} }
                });
                if (confMicTrackRef.current) { try { confMicTrackRef.current.stop(); } catch (_) {} }
                confMicTrackRef.current = null;
            }
            try {
                if (childSession && childSession.state !== SessionState.Terminated) {
                    // Inviter uses cancel() before Established, bye() after.
                    childSession.state === SessionState.Established
                        ? childSession.bye()
                        : childSession.cancel();
                }
            } catch (e) { console.warn('[Conf] child end error:', e); }
            conferenceSessionRef.current = null;

            closeMixContexts();

            // Re-point the parent's remote audio at its own remote track in case
            // the mix left the element wired to a mixer destination.
            const parentRemote = getRemoteTrack(activeCallSessionRef.current);
            const { remoteAudio, conferenceAudio } = setupMediaElements();
            if (remoteAudio && parentRemote) {
                remoteAudio.srcObject = new MediaStream([parentRemote]);
                remoteAudio.play().catch(() => {});
            }
            if (conferenceAudio) {
                conferenceAudio.srcObject = null;
                conferenceAudio.muted = false;
            }

            // If the parent was auto-held to set up the conference, release it.
            if (isHeldRef.current && activeCallSessionRef.current) {
                try { toggleHold(); } catch (_) {}
            }
        } catch (e) {
            console.error('[Conf] teardownConference error:', e);
        } finally {
            setConferencePanel(false);
            setConferenceDisplay('');
            setConferenceStatus('');
            setIsConfDialing(false);
            setIsConfReady(false);
            setIsConfJoined(false);
        }
    };

    // Open the conference dial panel. Puts the parent on hold so the agent can
    // speak privately to the third party while dialing. Mutually exclusive with
    // the transfer panel.
    const startConferenceCall = () => {
        if (!activeCallSessionRef.current) return;
        // Close transfer UI so the two panels never overlap.
        setTransferSelection(false);
        setTransferCalls(false);
        setExternalTransferCalls(false);
        setExternalAttendedTransferCalls(false);
        resetTransferSelection();

        if (conferencePanel || isConfJoined) {
            // Toggling off before a merge cancels; after a merge tears down.
            isConfJoined ? terminateConferenceCall() : cancelConference();
            return;
        }
        confTeardownGuardRef.current = false;
        setConferencePanel(true);
        setConferenceStatus('Enter a number to add to the call');
        if (!isHeldRef.current) { try { toggleHold(); } catch (_) {} }
    };

    // Close the panel WITHOUT having merged. Ends any half-dialed child leg and
    // takes the parent off hold.
    const cancelConference = () => {
        confTeardownGuardRef.current = false; // allow teardown to run
        teardownConference();
    };

    // Dial the third party as a SECOND independent SIP leg.
    const conferenceDial = (destinationRaw) => {
        if (!activeCallSessionRef.current || !userAgentRef.current) return;
        if (!destinationRaw) return;

        let dialednumber;
        const raw = String(destinationRaw);
        if (raw.length > 4) {
            const cleaned = raw.replace(/\D/g, '');
            if (/^0\d{9}$/.test(cleaned)) dialednumber = `254${cleaned.substring(1)}`;
            else if (/^254\d{9}$/.test(cleaned)) dialednumber = cleaned;
            else if (/^256\d{9}$/.test(cleaned)) dialednumber = cleaned;
            else if (/^\+\d+$/.test(raw.replace(/\s/g, ''))) dialednumber = raw.replace(/\s/g, '');
            else dialednumber = raw.replace(/\s/g, '');
        } else {
            dialednumber = raw.replace(/\s/g, '');
        }

        const Server_Url = sessionStorage.getItem('Server_Url');
        const target = UserAgent.makeURI(`sip:${dialednumber}@${Server_Url}`);
        if (!target) { console.error('[Conf] Invalid destination URI'); return; }

        const inviter = new Inviter(userAgentRef.current, target);
        conferenceSessionRef.current = inviter;
        setIsConfDialing(true);
        setIsConfReady(false);
        setConferenceStatus(`Calling ${dialednumber}...`);

        inviter.invite({
            sessionDescriptionHandlerOptions: {
                    constraints: SIP_AUDIO_CONSTRAINTS,
                },
        }).then(() => {
            inviter.stateChange.addListener((state) => {
                if (state === SessionState.Established) {
                    // Route the third party privately to the conference-audio
                    // element so the agent can talk to them while the parent is held.
                    const { conferenceAudio } = setupMediaElements();
                    const childRemote = getRemoteTrack(inviter);
                    if (conferenceAudio && childRemote) {
                        conferenceAudio.muted = false;
                        conferenceAudio.srcObject = new MediaStream([childRemote]);
                        conferenceAudio.play().catch(() => {});
                    }
                    setIsConfDialing(false);
                    setIsConfReady(true);
                    setConferenceStatus(`Connected to ${dialednumber} — press Merge to join all`);
                }
                if (state === SessionState.Terminated) {
                    inviter.stateChange.removeAllListeners();
                    // If the child drops (before OR after merge), collapse back to
                    // the original two-party call rather than killing everything.
                    if (isConfJoined) {
                        confTeardownGuardRef.current = false;
                        teardownConference();
                    } else {
                        conferenceSessionRef.current = null;
                        setIsConfDialing(false);
                        setIsConfReady(false);
                        setConferenceStatus('Third party unavailable');
                        const { conferenceAudio } = setupMediaElements();
                        if (conferenceAudio) conferenceAudio.srcObject = null;
                    }
                }
            });
        }).catch((e) => {
            console.error('[Conf] conferenceDial invite failed:', e);
            conferenceSessionRef.current = null;
            setIsConfDialing(false);
            setIsConfReady(false);
            setConferenceStatus('Failed to reach third party');
        });
    };

    // Cancel a ringing/answered child leg but keep the panel open so the agent
    // can dial a different number.
    const cancelConferenceDial = () => {
        const child = conferenceSessionRef.current;
        if (child) {
            try {
                child.state === SessionState.Established ? child.bye() : child.cancel();
            } catch (e) { console.warn('[Conf] cancelConferenceDial:', e); }
        }
        conferenceSessionRef.current = null;
        const { conferenceAudio } = setupMediaElements();
        if (conferenceAudio) conferenceAudio.srcObject = null;
        setIsConfDialing(false);
        setIsConfReady(false);
        setConferenceStatus('Enter a number to add to the call');
    };

    // THE MERGE. Build a mixed outgoing track for each leg and swap it in.
    //   parent sender gets:  agentMic + childRemote
    //   child  sender gets:  agentMic + parentRemote
    // Each party then hears the agent plus the other party. The AGENT continues
    // to hear party2 via the private conference-audio element (kept unmuted) and
    // party1 via remote-audio.
    const joinConferenceCall = () => {
        const parentSession = activeCallSessionRef.current;
        const childSession = conferenceSessionRef.current;
        const parentPc = parentSession?.sessionDescriptionHandler?.peerConnection;
        const childPc = childSession?.sessionDescriptionHandler?.peerConnection;
        if (!parentPc || !childPc) { console.error('[Conf] merge: missing peer connection'); return; }

        const parentSender = parentPc.getSenders().find(s => s.track && s.track.kind === 'audio');
        const childSender  = childPc.getSenders().find(s => s.track && s.track.kind === 'audio');
        const parentRemote = getRemoteTrack(parentSession);
        const childRemote  = getRemoteTrack(childSession);

        if (!parentSender?.track || !childSender?.track || !parentRemote || !childRemote) {
            console.error('[Conf] merge: tracks not ready', {
                ps: !!parentSender?.track, cs: !!childSender?.track,
                pr: !!parentRemote, cr: !!childRemote,
            });
            setConferenceStatus('Cannot merge yet — audio not ready');
            return;
        }

        // Save the PRISTINE mic tracks BEFORE swapping so we can restore later and
        // so recordStereo/relay never capture a doubled mix.
        parentMicTrackRef.current = parentSender.track;
        confMicTrackRef.current   = childSender.track;

        const parentMix = MixAudioStreams([parentSender.track, childRemote]);
        const childMix  = MixAudioStreams([childSender.track, parentRemote]);
        if (!parentMix || !childMix) {
            setConferenceStatus('Merge failed — audio mixer error');
            parentMicTrackRef.current = null;
            confMicTrackRef.current = null;
            closeMixContexts();
            return;
        }

        // Respect current mute state on the synthesized tracks.
        parentMix.enabled = !isMutedRef.current;
        childMix.enabled  = !isMutedRef.current;

        Promise.all([
            parentSender.replaceTrack(parentMix),
            childSender.replaceTrack(childMix),
        ]).then(() => {
            // ✅ FIX: keep conference-audio UNMUTED. After merge, remote-audio
            // plays party1 and parentMix is outbound-only (never played here),
            // so this element is the ONLY way the agent hears party2. Re-point
            // it at party2's live remote track and ensure it's audible.
            const { conferenceAudio } = setupMediaElements();
            if (conferenceAudio) {
                conferenceAudio.muted = false;
                if (childRemote) {
                    conferenceAudio.srcObject = new MediaStream([childRemote]);
                    conferenceAudio.play().catch(() => {});
                }
            }

            // ✅ FIX: splice party2 into the SAVE recording so the recorded file
            // captures all three parties. recordStereo panned party1 remote hard
            // right; add party2 to that same right-channel sink.
            spliceConfIntoRecording(childRemote);

            // Take the parent OFF hold so both parties are live.
            if (isHeldRef.current) { try { toggleHold(); } catch (_) {} }

            setIsConfJoined(true);
            setIsConfReady(false);
            setConferencePanel(false);
            setConferenceStatus('');
            console.log('[Conf] 3-way merge complete');
        }).catch((e) => {
            console.error('[Conf] replaceTrack during merge failed:', e);
            // Roll back cleanly.
            parentMicTrackRef.current = null;
            confMicTrackRef.current = null;
            closeMixContexts();
            setConferenceStatus('Merge failed');
        });
    };

    // Add party2's remote audio into the existing SAVE recording graph so the
    // stored recording contains all three parties. Uses the recording context
    // and the remote (right) panner created in recordStereo. No-op if the
    // recording graph isn't set up (e.g. tracks weren't ready).
    const spliceConfIntoRecording = (childRemoteTrack) => {
        try {
            const ctx = recordCtxRef.current;
            const remotePanner = recordRemotePannerRef.current;
            if (!ctx || !remotePanner || !childRemoteTrack) {
                console.warn('[Record] Conference splice skipped — graph not ready');
                return;
            }
            if (ctx.state === 'suspended') ctx.resume().catch(() => {});
            // Party2 shares the far-party (right) channel with party1.
            const confSource = ctx.createMediaStreamSource(new MediaStream([childRemoteTrack]));
            confSource.connect(remotePanner);
            confRecordSourceRef.current = confSource;
            console.log('[Record] Party2 spliced into save recording');
        } catch (e) {
            console.error('[Record] spliceConfIntoRecording failed:', e);
        }
    };

    // End the conference by dropping the third party but KEEPING the parent call.
    const terminateConferenceCall = () => {
        confTeardownGuardRef.current = false;
        teardownConference();
    };

    // ── recordStereo ──────────────────────────────────────────────────────────
    const recordStereo = (localTrack, remoteTrack) => {
        // Prevent multiple recorder instances
        if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
            console.log('[Audio] Save recorder already running');
            return;
        }

        if (audioCtxRef.current) {
            try { audioCtxRef.current.close(); } catch (e) { }
        }

        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        audioCtxRef.current = audioCtx;
        // Expose the recording context/panner so a later conference merge can
        // splice party2 into this same graph.
        recordCtxRef.current = audioCtx;

        // ✅ FIX: Ensure context is running so MediaStreamDestination doesn't produce silence
        if (audioCtx.state === 'suspended') {
            audioCtx.resume().catch(e => console.warn('[Audio] Failed to resume AudioContext:', e));
        }

        const destination = audioCtx.createMediaStreamDestination();
        const localSource  = audioCtx.createMediaStreamSource(new MediaStream([localTrack]));
        const remoteSource = audioCtx.createMediaStreamSource(new MediaStream([remoteTrack]));

        const localPanner  = audioCtx.createStereoPanner();
        localPanner.pan.value = -1;
        const remotePanner = audioCtx.createStereoPanner();
        remotePanner.pan.value = 1;
        // Keep the far-party (right) panner so party2 can join it on merge.
        recordRemotePannerRef.current = remotePanner;

        localSource.connect(localPanner).connect(destination);
        remoteSource.connect(remotePanner).connect(destination);

        // ── Save recorder (compliance / storage) ─────────────────────────
        const callIdForRecording = recording_call_id.current;
        const recorder = new MediaRecorder(destination.stream);
        mediaRecorderRef.current = recorder;
        recordedChunksRef.current = [];
        recorder.ondataavailable = (event) => {
            if (event.data.size > 0) recordedChunksRef.current.push(event.data);
        };
        recorder.onstop = () => {
            const blob = new Blob(recordedChunksRef.current, { type: 'audio/webm' });
            recordedChunksRef.current = [];
            uploadRecording(blob, callIdForRecording);
        };
        recorder.start();
        console.log('[Recording] Save recorder started');

        // [AUDIO] Live relay — keep the mixed stream so the relay recorder can
        // be restarted whenever a supervisor joins (REQUEST_CHUNK_RESEND).
        const callId = recording_call_id.current;
        liveStreamDestRef.current = destination.stream;
        if (callId && audioSocketRef.current?.connected) {
            console.log('[Audio] Setting up live relay for call:', callId);
            audioSocketRef.current.emit('REGISTER_CALL', { callId });
            startLiveRelay(callId);
        } else {
            console.warn('[Audio] Cannot start live relay - socket connected:', audioSocketRef.current?.connected, 'callId:', callId);
        }
    };

    // ── stopRecording ─────────────────────────────────────────────────────────
    const stopRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
            mediaRecorderRef.current.stop();
            console.log('[Recording] Save recorder stopped');
        }
        if (streamRecorderRef.current && streamRecorderRef.current.state !== 'inactive') {
            streamRecorderRef.current.stop();
            streamRecorderRef.current = null;
            console.log('[Audio] Live relay recorder stopped');
        }
        // Clear the conference recording splice + graph refs.
        detachConfFromRecording();
        recordRemotePannerRef.current = null;
        recordCtxRef.current = null;
        liveStreamDestRef.current = null;
        liveRelaySessionRef.current = null; // Invalidate session
        const callId = recording_call_id.current;
        if (callId && audioSocketRef.current?.connected) {
            audioSocketRef.current.emit('UNREGISTER_CALL', { callId });
        }
    };

    const uploadRecording = async (blob, callIdSnapshot = null) => {
        if (!blob || blob.size === 0) { console.warn('No recording found or file is empty.'); return; }
        const recording_id = callIdSnapshot ?? recording_call_id.current ?? '';
        if (!recording_id) { console.warn('[Recording] No call ID available — upload skipped'); return; }
        const formData = new FormData();
        formData.append('recording', blob, 'call_recording.webm');
        formData.append('recording_id', recording_id);
        try {
            const authyToken = localStorage.getItem(authToken);
            await api.post('/call/saverecording/', formData, {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'multipart/form-data' },
                withCredentials: true,
            });
            console.log('Recording uploaded');
        } catch (err) {
            console.error('Upload failed', err);
        }
    };

    const showCallNotification = (callerNumber) => {
        const displayName = contactName ? contactName : callerNumber;
        if (Notification.permission === 'granted') {
            new Notification(`Incoming Call (${displayName})`);
        } else if (Notification.permission !== 'denied') {
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') new Notification(`Incoming Call (${displayName})`);
            });
        }
    };

    const toggleMute = () => {
        if (!activeCallSessionRef.current?.sessionDescriptionHandler) return;
        try {
            const newMuteState = !isMuted;

            // During a merged conference the SENDER tracks are synthesized mixes
            // (IsMixedTrack). Disabling those would silence BOTH the agent and the
            // far party. Instead we gate the agent's real mic at its source — the
            // pristine tracks we stashed on merge — which flow into both mixers.
            if (isConfJoined) {
                [parentMicTrackRef.current, confMicTrackRef.current].forEach(t => {
                    if (t) t.enabled = !newMuteState;
                });
                // Belt-and-braces: also toggle any non-mixed audio senders on both
                // legs (covers the moment right after a track restore).
                [activeCallSessionRef.current, conferenceSessionRef.current].forEach(sess => {
                    const pc = sess?.sessionDescriptionHandler?.peerConnection;
                    if (!pc) return;
                    pc.getSenders()
                        .filter(s => s.track && s.track.kind === 'audio' && !s.track.IsMixedTrack)
                        .forEach(s => { s.track.enabled = !newMuteState; });
                });
                setIsMuted(newMuteState);
                return;
            }

            // Normal (2-party) path.
            const peerConnection = activeCallSessionRef.current.sessionDescriptionHandler.peerConnection;
            if (peerConnection) {
                peerConnection.getSenders()
                    .filter(s => s.track && s.track.kind === 'audio')
                    .forEach(s => { s.track.enabled = !newMuteState; });
                setIsMuted(newMuteState);
            }
        } catch (error) {
            console.error('Error toggling mute:', error);
        }
    };

    const toggleDTMF = () => {
        if (activeCallSessionRef.current) {
            const newDtmfState = !dtmfButtons;
            setDtmfButtons(newDtmfState);
            if (!newDtmfState) setDTMFValue('');
        }
    };

    const toggleHold = () => {
        try {
            if (!activeCallSessionRef.current) return;

            // A SIP re-INVITE hold renegotiates SDP, which would tear down the
            // replaceTrack()-swapped mixed audio. During a merged conference we
            // therefore emulate hold LOCALLY: disable the mixed sender tracks and
            // silence the far parties' inbound audio, without touching signaling.
            if (isConfJoined) {
                const newHoldState = !isHeld;
                [activeCallSessionRef.current, conferenceSessionRef.current].forEach(sess => {
                    const pc = sess?.sessionDescriptionHandler?.peerConnection;
                    if (!pc) return;
                    pc.getSenders()
                        .filter(s => s.track && s.track.kind === 'audio')
                        .forEach(s => { s.track.enabled = !newHoldState; });
                });
                // ✅ FIX: mute BOTH monitor elements on hold. remote-audio carries
                // party1, conference-audio carries party2 — silencing only one
                // would leave the agent still hearing the other while "on hold".
                const { remoteAudio, conferenceAudio } = setupMediaElements();
                if (remoteAudio) remoteAudio.muted = newHoldState;
                if (conferenceAudio) conferenceAudio.muted = newHoldState;
                setIsHeld(newHoldState);
                return;
            }

            const newHoldState = !isHeld;
            const options = { sessionDescriptionHandlerOptions: { hold: newHoldState } };
            activeCallSessionRef.current.invite(options)
                .then(() => console.log(newHoldState ? 'On hold' : 'Off hold'))
                .catch(e => console.error('Hold toggle failed:', e));
            setIsHeld(newHoldState);
        } catch (error) {
            console.error('Error toggling hold:', error);
        }
    };

    const sendDTMF = (tone) => {
        setDTMFValue(dTMFValue + tone);
        // While the conference panel is open and the child leg is live (dialing or
        // connected but not yet merged), the third party is the leg the agent is
        // actively working with — e.g. keying through the third party's IVR — so
        // DTMF goes there. Once merged (or no child), it goes to the parent call.
        const child = conferenceSessionRef.current;
        const targetSession =
            (!isConfJoined && child && child.state !== SessionState.Terminated && child.sessionDescriptionHandler)
                ? child
                : activeCallSessionRef.current;
        if (targetSession?.sessionDescriptionHandler) {
            try {
                targetSession.sessionDescriptionHandler.sendDtmf(tone);
            } catch (error) {
                console.error('Error sending DTMF tone:', error);
            }
        }
    };

    const forwardAttendedExternalCall = (destination) => {
        if (!activeCallSessionRef.current || !userAgentRef.current) return;
        if (!isHeld) toggleHold();
        let dialednumber;
        if (destination.length > 4) {
            const cleanedNumber = destination.replace(/\D/g, '');
            if (/^0\d{9}$/.test(cleanedNumber)) dialednumber = `254${cleanedNumber.substring(1)}`;
            else if (/^254\d{9}$/.test(cleanedNumber)) dialednumber = cleanedNumber;
            else dialednumber = destination.replace(/\s/g, '');
        } else {
            dialednumber = destination.replace(/\s/g, '');
        }
        setWarmTransferTarget(dialednumber);
        const Server_Url = sessionStorage.getItem('Server_Url');
        const target = UserAgent.makeURI(`sip:${dialednumber}@${Server_Url}`);
        if (!target) { console.error('Invalid destination URI for warm transfer'); return; }
        const inviter = new Inviter(userAgentRef.current, target);
        setConsultationSession(inviter);
        inviter.invite({
            sessionDescriptionHandlerOptions: {
                constraints: SIP_AUDIO_CONSTRAINTS,
            },
        })
            .then(() => {
                setIsInWarmTransfer(true);
                setConsultationSession(inviter);
                inviter.stateChange.addListener((state) => {
                    if (state === SessionState.Established) {
                        attachMediaStreams(inviter);
                        setIsConsultationReady(true);
                    }
                    if (state === SessionState.Terminated) {
                        setIsInWarmTransfer(false);
                        setIsConsultationReady(false);
                        setConsultationSession(null);
                        if (isHeld) toggleHold();
                    }
                });
            })
            .catch(error => {
                console.error('Error initiating consultation call:', error);
                setIsInWarmTransfer(false);
                setIsConsultationReady(false);
                if (isHeld) toggleHold();
            });
    };

    const completeWarmTransfer = () => {
        if (!activeCallSessionRef.current || !consultationSession) return;
        try {
            const Server_Url = sessionStorage.getItem('Server_Url');
            const target = UserAgent.makeURI(`sip:${warmTransferTarget}@${Server_Url}`);
            if (!target) { console.error('Invalid target for completing transfer'); return; }
            activeCallSessionRef.current.refer(target);
            if (consultationSession.state !== SessionState.Terminated) consultationSession.bye();
            setConsultationSession(null);
            setIsInWarmTransfer(false);
            setWarmTransferTarget('');
            handleDroppedCallUI();
        } catch (error) {
            console.error('Warm transfer failed:', error);
        }
    };

    const cancelWarmTransfer = () => {
        if (consultationSession) {
            try {
                if (consultationSession.state !== SessionState.Terminated) consultationSession.bye();
            } catch (error) {
                console.error('Error canceling consultation:', error);
            }
        }
        setConsultationSession(null);
        setIsInWarmTransfer(false);
        setWarmTransferTarget('');
        if (isHeld) toggleHold();
    };

    const forwardCall = (destination) => {
        if (destination) {
            let dialednumber;
            if (destination > 4) {
                const DialNumber = destination.replace(/\s/g, '');
                const cleanedNumber = DialNumber.replace(/\D/g, '');
                if (/^0\d{9}$/.test(cleanedNumber)) dialednumber = `254${cleanedNumber.substring(1)}`;
                else if (/^254\d{9}$/.test(cleanedNumber)) dialednumber = cleanedNumber;
                else dialednumber = DialNumber;
            } else {
                dialednumber = destination.replace(/\s/g, '');
            }
            if (activeCallSessionRef.current) {
                try {
                    const Server_Url = sessionStorage.getItem('Server_Url');
                    const target = UserAgent.makeURI(`sip:${dialednumber}@${Server_Url}`);
                    if (!target) { console.error('Invalid destination URI for forwarding'); return; }
                    activeCallSessionRef.current.refer(target);
                } catch (error) {
                    console.error('Error forwarding call:', error);
                }
            }
        }
    };

    // ── Campaign ──────────────────────────────────────────────────────────────
    const fetchAllCampaignContacts = async () => {
        try {
            const batchSize = 200;
            let allContacts = [];
            const initialResponse = await api.get('/campaign/assigned', {
                params: { limit: batchSize, offset: 0, search: searchText || '' },
                headers: { Authorization: `Bearer ${authyToken}` },
            });
            allContacts = initialResponse.data.data;
            const totalContacts = initialResponse.data.total;
            if (allContacts.length < totalContacts) {
                const pagesNeeded = Math.ceil((totalContacts - batchSize) / batchSize);
                const remainingRequests = Array.from({ length: pagesNeeded }, (_, i) =>
                    api.get('/campaign/assigned', {
                        params: { limit: batchSize, offset: (i + 1) * batchSize, search: searchText || '' },
                        headers: { Authorization: `Bearer ${authyToken}` },
                    })
                );
                const responses = await Promise.all(remainingRequests);
                responses.forEach(res => { allContacts = [...allContacts, ...res.data.data]; });
            }
            return allContacts;
        } catch (error) {
            console.error('Error fetching campaign contacts:', error);
            return [];
        }
    };

    // ── Reset ALL campaign state to a known-clean slate ─────────────────────
    // Called before every start and after every stop/completion so a second
    // run never inherits stale index/guard/contact-list values from the first.
    const resetCampaignState = () => {
        if (campaignTimeoutRef.current) {
            clearTimeout(campaignTimeoutRef.current);
            campaignTimeoutRef.current = null;
        }
        clearWrapUp();
        campaignModeRef.current = false;
        campaignContactsRef.current = [];
        currentContactIndexRef.current = 0;
        setCurrentContactIndex(0);
        // Clear the completion latch so the NEXT campaign can run. Safe because
        // startCampaign re-enables campaignModeRef immediately after calling this.
        campaignDoneRef.current = false;
        // Neutral guard so a lingering timeout/advance can't fire against it
        callLoggedRef.current = { done: true, advanced: true, contactIndex: null };
        callEstablishedRef.current = false;
    };

    const startCampaign = async (contactListParam) => {
        // Prevent overlapping campaigns — the ref is synchronous, so it (not the
        // async campaignMode state) is what actually guards against re-entry.
        if (campaignModeRef.current) {
            console.warn('[Campaign] Already running — ignoring start');
            return;
        }
        // Start every run from a clean slate
        resetCampaignState();

        let contactList = contactListParam;
        if (!contactList) contactList = await fetchAllCampaignContacts();
        if (!contactList || contactList.length === 0) { console.warn('No contacts available.'); return; }
        setCampaignMode(true);
        campaignModeRef.current = true;
        setCampaignContacts(contactList);
        campaignContactsRef.current = contactList;
        setCurrentContactIndex(0);
        currentContactIndexRef.current = 0;
        dialNextContact(contactList, 0);
        setSelectedDailerTab(0);
    };

    const dialNextContact = (contactList, index) => {
        // If completion already ran (latched), never dial again — this stops a
        // stale timeout or duplicate end-event from re-dialing the last contact.
        if (campaignDoneRef.current && index < contactList.length) {
            return;
        }
        if (index >= contactList.length) {
            campaignDoneRef.current = true; // latch before teardown
            setCampaignMode(false);
            notifyAutoDialer(false);
            // Full teardown so the next run starts clean
            resetCampaignState();
            return;
        }
        const contact = contactList[index];
        const phoneNumber = contact.phone_number || contact.phone;
        clearWrapUp(); // ensure countdown is gone when dialing starts
        setDialDisplay(phoneNumber);
        setDialerNumber(phoneNumber);
        setCurrentContactIndex(index);
        currentContactIndexRef.current = index;
        makeCall(phoneNumber);

        // ✅ FIX B: Clear any prior timeout before arming a new one, and make the
        // timeout hang up (which now advances internally) using THIS contact's guard.
        if (campaignTimeoutRef.current) clearTimeout(campaignTimeoutRef.current);

        // Capture the guard created by makeCall for this specific contact so the
        // timeout acts only on this call and not a later one.
        const guardForThisContact = callLoggedRef.current;

        campaignTimeoutRef.current = setTimeout(() => {
            // Only act if THIS contact's call is still unresolved and was never picked up
            if (guardForThisContact && !guardForThisContact.done && !callEstablishedRef.current) {
                // hangUpCallOutGoing sets guard.done, logs "No Answer", and advances
                hangUpCallOutGoing();
            }
        }, campaignTimeout * 1000);
    };

    const stopCampaign = () => {
        setDialDisplay('');
        setCampaignMode(false);
        notifyAutoDialer(false);
        resetCampaignState();
    };

    useEffect(() => {
        const fetchConfigsIfNeeded = async () => {
            const cachedWsServer = sessionStorage.getItem('WsServer');
            if (cachedWsServer) {
                setupSIPClient();
            } else {
                try {
                    setVoipSignalStatus('#1E90FF');
                    const response = await api.get('/user/usercallconfigs', {
                        headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
                        withCredentials: true,
                    });
                    sessionStorage.setItem('WsServer', response.data.wsServer);
                    sessionStorage.setItem('Extension', response.data.authorizationUser);
                    sessionStorage.setItem('ExtPass', response.data.extPass);
                    sessionStorage.setItem('Uri', response.data.Uri);
                    sessionStorage.setItem('Server_Url', response.data.Server_Url);
                    setupSIPClient();
                } catch (error) {
                    console.error('Error fetching configs:', error);
                    setVoipSignalStatus('#FF160C');
                }
            }
        };
        fetchConfigsIfNeeded();
        return () => {
            try { userAgentRef.current?.stop(); } catch (e) { console.error(e); }
            if (registrationTimeoutRef.current) clearTimeout(registrationTimeoutRef.current);
            if (connectivityCheckIntervalRef.current) clearInterval(connectivityCheckIntervalRef.current);
            if (statusCheckIntervalRef.current) clearInterval(statusCheckIntervalRef.current);
        };
    }, []);

    // ── Contact name lookup ───────────────────────────────────────────────────
    // Shared by incoming, outgoing (makeCall), live dial-pad typing, and paste.
    // Backend may return a single { name, phone_number } or { matches: [...] }.
    const contactLookupSeqRef = useRef(0);
    // After the agent picks one match, lock the list to that single row until they type again.
    const contactSelectionLockedRef = useRef(false);
    const lockedContactPhoneRef = useRef('');

    const clearContactMatch = () => {
        setContactName('');
        setMatchedContactPhone('');
        setContactMatches([]);
        contactSelectionLockedRef.current = false;
        lockedContactPhoneRef.current = '';
    };

    const handleContactName = async (dialednumber) => {
        if (!dialednumber) {
            clearContactMatch();
            return;
        }
        const seq = ++contactLookupSeqRef.current;
        try {
            let cleaned = String(dialednumber).replace(/\s/g, '');
            // Mirror makeCall normalization so search hits the same stored form
            const digits = cleaned.replace(/\D/g, '');
            if (/^0\d{9}$/.test(digits)) {
                cleaned = `254${digits.substring(1)}`;
            } else if (/^254\d{9}$/.test(digits) || /^256\d{9}$/.test(digits)) {
                cleaned = digits;
            } else if (/^\+\d+$/.test(cleaned)) {
                cleaned = cleaned;
            } else if (digits) {
                cleaned = digits;
            }
            // For name-typed queries keep original letters; for pure numbers use cleaned
            const hasLetters = /[a-zA-Z]/.test(String(dialednumber));
            const searchKey = hasLetters
                ? String(dialednumber).trim()
                : (cleaned.replace(/^(\+254|254|0)/, '') || cleaned);

            const response = await api.get(`/contact/contactsearch/${encodeURIComponent(searchKey)}`, {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
                withCredentials: true,
            });

            if (seq !== contactLookupSeqRef.current) return;

            const data = response.data || {};
            // Prefer explicit matches[] from multi-result API; fall back to single object
            let list = Array.isArray(data.matches) ? data.matches : [];
            if (list.length === 0 && (data.name || data.phone_number || data.phone)) {
                list = [{
                    name: data.name || null,
                    phone_number: data.phone_number || data.phone || data.number || data.mobile || null,
                    alternative_phone_number: data.alternative_phone_number || null,
                    type: data.type || null,
                }];
            }

            // Flatten primary + alternative into separate tappable rows
            const flattened = [];
            for (const m of list) {
                const name = m?.name || null;
                if (m?.phone_number) {
                    flattened.push({
                        name,
                        phone_number: String(m.phone_number),
                        label: m.label || (m.alternative_phone_number ? 'Primary' : null),
                        type: m.type || null,
                    });
                }
                if (m?.alternative_phone_number) {
                    flattened.push({
                        name,
                        phone_number: String(m.alternative_phone_number),
                        label: m.label || 'Alt',
                        type: m.type || null,
                    });
                }
                // Name-only row (no phone) — still show, but not tappable for paste
                if (!m?.phone_number && !m?.alternative_phone_number && name) {
                    flattened.push({
                        name,
                        phone_number: cleaned || null,
                        label: null,
                        type: m.type || null,
                    });
                }
            }

            setContactMatches(flattened);
            setContactName(flattened[0]?.name || '');
            setMatchedContactPhone(flattened[0]?.phone_number || '');
        } catch (error) {
            if (seq === contactLookupSeqRef.current) {
                clearContactMatch();
            }
        }
    };

    // Click a match row → paste that number and keep ONLY the clicked contact visible
    const applyMatchedContact = (matchOrPhone) => {
        const match = (matchOrPhone && typeof matchOrPhone === 'object')
            ? matchOrPhone
            : { phone_number: matchOrPhone || matchedContactPhone, name: contactName || null };
        const number = match.phone_number;
        if (!number) return;

        // Invalidate any in-flight search so it can't overwrite this selection
        contactLookupSeqRef.current += 1;
        contactSelectionLockedRef.current = true;
        lockedContactPhoneRef.current = String(number);

        setDialDisplay(String(number));
        setMatchedContactPhone(String(number));
        setContactName(match.name || '');
        // Show only the selected contact
        setContactMatches([{
            name: match.name || null,
            phone_number: String(number),
            label: match.label || null,
            type: match.type || null,
        }]);
    };

    // Live lookup while keying digits / name / after paste into the dial field.
    // Debounced so we don't hit the API on every keystroke.
    useEffect(() => {
        const value = (dialdisplay || '').trim();
        if (!value) {
            clearContactMatch();
            return;
        }

        // If agent already picked a contact, don't re-search while the field still holds that number
        if (contactSelectionLockedRef.current) {
            const lockedPhone = String(lockedContactPhoneRef.current || '').trim();
            if (lockedPhone && value === lockedPhone) {
                return; // keep single selected contact visible
            }
            // User edited the number — unlock and allow a new search
            contactSelectionLockedRef.current = false;
            lockedContactPhoneRef.current = '';
        }

        const digits = value.replace(/\D/g, '');
        const hasLetters = /[a-zA-Z]/.test(value);
        // Search once it looks useful: name text, extension, or full MSISDN
        const looksComplete =
            hasLetters ||
            digits.length >= 4 ||
            /^0\d{9}$/.test(digits) ||
            /^254\d{9}$/.test(digits) ||
            /^256\d{9}$/.test(digits) ||
            /^\+\d{8,}$/.test(value.replace(/\s/g, ''));

        if (!looksComplete) {
            clearContactMatch();
            return;
        }

        const timer = setTimeout(() => {
            handleContactName(value);
        }, 400);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dialdisplay]);

    // Re-populate parent disposition fields from the LIVE call after the modal
    // closes. Needed when call 2 was answered while the modal was still open
    // for call 1 (those sets were skipped by the guard).
    const syncDispositionFromActiveCall = () => {
        const hasLiveCall =
            !!activeCallSessionRef.current ||
            !!incomingCallSessionRef.current ||
            !!outgoingCallSessionRef.current;
        if (!hasLiveCall) {
            setDispositionContact('');
            setCallType('');
            return;
        }
        const number =
            dialerNumber ||
            incomingNumber ||
            dialedNumberRef.current ||
            dialdisplay ||
            '';
        setDispositionContact(number);

        // Prefer explicit callType; otherwise infer from which session is live.
        let type = callType || callTypeCallLog || '';
        if (!type) {
            if (incomingCallSessionRef.current) type = 'incoming';
            else if (outgoingCallSessionRef.current) type = 'outgoing';
        }
        setCallType(type);
    };

    const handleOpenAddDispositionModal = () => {
        // Snapshot current call context into modal-local state. The form binds
        // to these copies only, so a later incoming/outgoing call (or UI reset)
        // cannot change the number / call type the agent is filling in.
        dispositionModalOpenRef.current = true;
        const number =
            dispositionContact ||
            dialerNumber ||
            incomingNumber ||
            dialedNumberRef.current ||
            dialdisplay ||
            '';
        let type = callType || callTypeCallLog || '';
        if (!type) {
            if (incomingCallSessionRef.current) type = 'incoming';
            else if (outgoingCallSessionRef.current) type = 'outgoing';
        }
        setModalDispositionContact(number);
        setModalCallType(type);
        setAddDispositionModal(true);
        fetchDispositionList();
        fetchDispositionCategory();
    };

    const handleCloseAddDispositionModal = () => {
        dispositionModalOpenRef.current = false;
        setAddDispositionModal(false);
        setModalDispositionContact('');
        setModalCallType('');
        // If another call is already live, re-sync parent fields to that call
        // so the next open gets the correct number / type.
        syncDispositionFromActiveCall();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewDisposition({ ...newDisposition, [name]: value });
    };

    const handleInputBreakChange = (event) => {
        const { value } = event.target;
        setBreakType(value);
        sessionStorage.removeItem('breakType');
        if (value) {
            setBreakDrop('none');
            setBreakBtn('');
            sessionStorage.setItem('breakType', value);
        }
        const authyToken = localStorage.getItem(authToken);
        const breakId = `break_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        sessionStorage.setItem('break', breakId);
        api.post('/break/add', { break_id: breakId, break_type: value }, {
            headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            withCredentials: true,
        })
            .then(() => handleWebsocketTakeBreak())
            .catch((error) => {
                console.error('[Break] Failed to start break:', error);
                resetTime();
                setBreakDrop('');
                setBreakType('');
                setBreakBtn('none');
                sessionStorage.removeItem('break');
            });
    };

    const handleDispositionSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const authyToken = localStorage.getItem(authToken);
        api.post('/disposition/add', formData, {
            headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            withCredentials: true,
        })
            .then(() => {
                dispositionModalOpenRef.current = false;
                setAddDispositionModal(false);
            })
            .catch(console.error);
        // Clear modal copies; re-sync parent fields from any live call so the
        // next open (e.g. call 2 answered while this modal was open) is correct.
        dispositionModalOpenRef.current = false;
        setModalDispositionContact('');
        setModalCallType('');
        syncDispositionFromActiveCall();
    };

    const fetchDispositionList = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/disposition/list', {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            });
            setDispositionList(response.data.data);
        } catch (error) {
            console.error('Error fetching Disposition Group:', error);
        }
    };

    // recordingIdOverride: pass an explicit snapshot so races with handleDroppedCallUI
    // cannot wipe recording_call_id before the POST body is built.
    const handleAddCallLog = async (
        duration,
        type,
        destination,
        source,
        disconnectDirection = null,
        recordingIdOverride = null,
    ) => {
        const NON_ANSWERED = [
            'Missed', 'Flashed', 'No Answer', 'Canceled', 'Rejected',
            'Failed', 'Busy', 'Invalid Number', 'Forbidden', 'Timeout',
        ];

        // Prefer explicit override (hangup snapshots) over the live ref
        const snapshotRecordingId =
            recordingIdOverride ?? recording_call_id.current ?? null;
        const snapshotDestination =
            type === 'outgoing'
                ? (dialedNumberRef.current ?? destination)
                : destination;
        const snapshotContactName = contactName || '';

        // Always attach recording_id for answered calls:
        //   - "Picked" (intermediate marker on accept)
        //   - real HH:MM:SS duration on hangup
        const attachRecordingId =
            !!snapshotRecordingId &&
            (duration === 'Picked' || !NON_ANSWERED.includes(duration));

        if (!source || !snapshotDestination || !duration || !type) {
            console.warn('[CallLog] Missing required parameters — skipping log:', {
                duration,
                type,
                destination: snapshotDestination,
                source,
            });
            return;
        }

        const params = {
            duration,
            type,
            destination: snapshotDestination,
            source,
            contactsavedname: snapshotContactName,
            ...(attachRecordingId && { recording_id: snapshotRecordingId }),
            ...(disconnectDirection && { disconnect_direction: disconnectDirection }),
        };

        console.log('[CallLog] posting', {
            duration: params.duration,
            type: params.type,
            destination: params.destination,
            source: params.source,
            recording_id: params.recording_id || null,
            disconnect_direction: params.disconnect_direction || null,
        });

        const addCallToDatabase = async () => {
            try {
                const authyToken = localStorage.getItem(authToken);
                const response = await api.post('/call/add', params, {
                    headers: {
                        Authorization: `Bearer ${authyToken}`,
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                });
                console.log('[CallLog] server response', response?.data);
                updateCallLogsUpdate();
                return response;
            } catch (error) {
                console.error('[CallLog] API post failed:', error);
                throw error;
            }
        };

        if (duration === 'Picked') {
            const call_id = snapshotRecordingId ?? '';
            startCall('incoming', call_id, source, snapshotDestination);
        }

        // Short delay for Missed/Flashed so a late race (other agent answer) can still
        // correct the log if needed; Flashed uses the same path.
        if (params.duration === 'Missed' || params.duration === 'Flashed') {
            setTimeout(addCallToDatabase, 10000);
        } else {
            await addCallToDatabase();
            dialedNumberRef.current = null;
            updateCallLogsUpdate();
        }
    };

    useEffect(() => {
        return () => {
            resetTimer();
            handleContactName('');
            stopEndTone();
            stopIncomingTone();
            stopOutgoingTone();
        };
    }, []);

    const handleTakingBreakClose = () => {
        resetTime();
        setTakingBreakOpen(false);
        setBreakDrop('');
        setBreakType('');
        setBreakBtn('none');
        setTakeBreak(false);
        takeBreakRef.current = false;
        setAutoAnswer(false);
        autoAnswerRef.current = false;
        const breakId = sessionStorage.getItem('break');
        if (socketRef.current) {
            socketRef.current.emit('END_BREAK', { breakId });
            socketRef.current.emit('SEND_BREAK_UPDATE');
        }
        const authyToken = localStorage.getItem(authToken);
        api.post('/break/add', { break_id: breakId }, {
            headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            withCredentials: true,
        })
            .then(() => {
                resetTime();
                takeBreakRef.current = false;
                sessionStorage.removeItem('break');
            })
            .catch(console.error);
        resetTime();
    };

    const handleWebsocketTakeBreak = () => {
        if (!socketRef.current?.connected) {
            console.warn('[Break] Socket not connected, retrying in 1s');
            setTimeout(handleWebsocketTakeBreak, 1000);
            return;
        }
        const breakId = sessionStorage.getItem('break');
        const breakTypeValue = sessionStorage.getItem('breakType');
        socketRef.current.emit('START_BREAK', {
            breakId,
            breakType: breakTypeValue || 'General Break',
            timestamp: new Date().toISOString(),
        });
    };

    useEffect(() => {
        const sock = socketRef.current;
        if (!sock) return;
        const handleDropBreak = ({ breakId }) => {
            if (breakId === sessionStorage.getItem('break')) handleTakingBreakClose();
        };
        sock.on('NEW_DROP_BREAK', handleDropBreak);
        return () => sock.off('NEW_DROP_BREAK', handleDropBreak);
    }, []);

    const startCall = (callType, callId, callTo, callFrom) => {
        if (!socketRef.current) return;
        const isOutgoing = callType === 'outgoing';
        socketRef.current.emit('CALL_STARTED', {
            callType,
            callId,
            callTo: isOutgoing ? callFrom : callTo,
            callFrom: isOutgoing ? callTo : callFrom,
            agentName: sessionStorage.getItem('user_name'),
            status: 'active',
            startTime: new Date().toISOString(),
        });
    };

    const startCallOutGoing = () => {
        if (!socketRef.current) return;
        socketRef.current.emit('CALL_STARTED', {
            callType: 'outgoing',
            callId: recording_call_id.current ?? '',
            callTo: dialedNumberRef.current,
            callFrom: sessionStorage.getItem('extension'),
            agentName: sessionStorage.getItem('user_name'),
            status: 'active',
            startTime: new Date().toISOString(),
        });
    };

    const updateCallLogsUpdate = () => {
        updateCallsDataEvent();
        socketRef.current?.emit('SEND_CALL_LOG_UPDATE');
    };

    const endCall = () => {
        const callId = recording_call_id.current ?? '';
        if (!callId) { console.warn('No call ID provided'); return; }
        socketRef.current?.emit('END_CALL', { callId });
    };

    const fetchDispositionCategory = async () => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get('/disposition/category', {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            });
            setDispositionCategory(response.data.data);
        } catch (error) {
            console.error('Error fetching Disposition Category:', error);
        }
    };

    const handleShowSubCategoryDropdown = async (id) => {
        try {
            const authyToken = localStorage.getItem(authToken);
            const response = await api.get(`/disposition/subcategory/${id}`, {
                headers: { Authorization: `Bearer ${authyToken}`, 'Content-Type': 'application/json' },
            });
            setSubCategorDataDropDown(response.data.data);
        } catch (error) {
            console.error('Error fetching Disposition Sub Category:', error);
        }
    };

    const handleInputCatChange = (event) => {
        const { value } = event.target;
        const selectedCategory = dispositionCategory.find(cat => cat.category === value);
        if (selectedCategory) handleShowSubCategoryDropdown(selectedCategory.id);
    };

    useEffect(() => {
        const handleCopyPhone = (event) => {
            const number = event.detail;
            setDialDisplay(number);
            setSelectedDailerTab(0);
            // Instant lookup on paste — the dialdisplay effect will also fire,
            // but this avoids waiting for the 400ms debounce when pasting a full number.
            if (number) handleContactName(number);
        };
        window.addEventListener('copyPhoneNumber', handleCopyPhone);
        return () => window.removeEventListener('copyPhoneNumber', handleCopyPhone);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateCallsDataEvent = () => {
        window.dispatchEvent(new CustomEvent('updateCallsDataEvent', { detail: 'callsDataEventActive' }));
    };

    const handleTransferSelect = (buttonType) => {
        setActiveTransferButton(buttonType);
        const actions = {
            'attended-internal': () => { setUnattendedInternalStatus(false); setTransferCalls(true); handleGetTransferToUsers(); },
            'unattended-internal': () => { setUnattendedInternalStatus(true); setTransferCalls(true); handleGetTransferToUsers(); },
            'attended-external': () => { setExternalAttendedTransferCalls(true); },
            'unattended-external': () => { setExternalTransferCalls(true); },
        };
        const action = actions[buttonType];
        if (action) action();
        else console.warn('Unknown button type:', buttonType);
    };

    const resetTransferSelection = () => {
        setActiveTransferButton(null);
        setExternalAttendedTransferCalls(false);
    };

    const notifyAutoDialer = (value) => {
        window.dispatchEvent(new CustomEvent('notifyAutoDialer', { detail: value ? '#FF9800' : 'inherit' }));
    };

    const handleRingtoneMuteToggle = () => {
        const newMuteState = !isRingtoneMuted;
        setIsRingtoneMuted(newMuteState);
        if (newMuteState) stopIncomingTone();
        else playIncomingTone();
    };

    // ── Online presence ───────────────────────────────────────────────────────
    useEffect(() => {
        if (!socket) return;
        const fetchPresence = async () => {
            try {
                const authyToken = localStorage.getItem(authToken);
                const headers = { Authorization: `Bearer ${authyToken}` };
                const decoded = jwtDecode(authyToken);
                const orgId = decoded.organization_id;
                const response = await api.get(`/presence/${orgId}`, { headers, withCredentials: true });
                const ids = new Set(response.data.map(u => String(u.userId)));
                setOnlineUsers(ids);
            } catch (err) {
                console.error('Failed to fetch presence:', err);
            }
        };
        fetchPresence();
        const handlePresence = ({ userId, status }) => {
            setOnlineUsers(prev => {
                const updated = new Set(prev);
                if (status === 'online') updated.add(String(userId));
                else updated.delete(String(userId));
                return updated;
            });
        };
        socket.on('USER_PRESENCE', handlePresence);
        return () => {
            socket.off('USER_PRESENCE', handlePresence);
        };
    }, [socket]);

    return (
        <Box sx={{ display: 'flex', }}>
            <CssBaseline />
            <Drawer
                sx={{
                    width: drawerWidth,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        zIndex: 1,
                    },
                }}
                variant="permanent"
                anchor="right"
                open={false}
                onClose={onClose}
            >
                <Toolbar />
                <Box sx={{width:'100%', borderBottom:`3px solid ${voipSignalStatus}`, marginTop:'-15px'}}></Box>

                {selectedDailerTab === 0 &&  <span>

                    {/* RECEIVING PHONE */}
                    <Grid container spacing={1} sx={{ display: showIncomingCall ? 'flex' : 'none', mb: 1 , p:4}}>
                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center"}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h6' sx={{marginTop:'20px'}}>INCOMING CALL</Typography>
                                <span>  <IconButton sx={{color:'inherit',marginTop:'20px'}}>
                                    <ShakingRingVolumeIcon sx={{ fontSize: "60px" }} />
                                </IconButton></span>
                                <span>
                                    <Typography sx={{fontSize: "23px;"}}>
                                        {contactName ? contactName : dialerNumber}
                                    </Typography>
                                </span>
                                <span>
                                    <Typography sx={{fontSize: "20px;"}}>
                                        {incomingNumber}
                                    </Typography>
                                </span>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ display: hideCallButtonsAccept ? 'flex' : 'none', justifyContent: 'space-between', width: '100%', mt: 2 ,fontSize: 14}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.success.main} !important` ,
                                }}
                                onClick={acceptCallHandler}
                            >
                                <LocalPhone sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>

                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.error.main} !important`,
                                }}
                                onClick={rejectCallHandler}
                            >
                                <PhoneDisabled sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>
                        </Grid>

                        <Grid item xs={12} sx={{ display: RingtoneIcon ? 'flex':'none', gridColumn: "span 12", textAlign: "center", justifyContent: "center", marginTop:"10px"}}>
                            <Divider/>
                            <Box>
                                <Typography>{isRingtoneMuted ? "Unmute" : "Mute"} Ringtone</Typography>
                                <IconButton onClick={handleRingtoneMuteToggle} aria-label={isRingtoneMuted ? "Unmute" : "Mute"}>
                                    {isRingtoneMuted ? <VolumeOff sx={{fontSize:'1.8rem'}}/> : <VolumeUp sx={{fontSize:'1.8rem'}}/>}
                                </IconButton>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center"}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span>
                                    <Typography sx={{fontSize: "15px;", fontWeight:"lighter"}}>
                                        {showConnecting}
                                    </Typography>
                                </span>
                            </div>
                        </Grid>
                    </Grid>

                    {/* MAKING PHONE CALL */}
                    <Grid container spacing={1} sx={{ display: showMakingCall ? 'flex' : 'none', mb: 1 , p:4}}>
                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center"}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h6' sx={{marginTop:'20px'}}>{isRinging}</Typography>
                                <span>  <IconButton sx={{color:'inherit'}}>
                                    <PermIdentity sx={{ fontSize: "60px" }} />
                                </IconButton></span>
                                <span>
                                    <Typography sx={{fontSize: "23px;"}}>
                                        {contactName ? contactName : dialerNumber}
                                    </Typography>
                                </span>
                                <span>
                                    <Typography sx={{fontSize: "20px;"}}>
                                        {dialerNumber}
                                    </Typography>
                                </span>
                            </div>
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 2 ,fontSize: 14}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.error.main} !important`,
                                }}
                                onClick={hangUpCallOutGoing}
                            >
                                <LocalPhone sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>
                        </Grid>
                    </Grid>

                    {/* ACTIVE CALL */}
                    <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, display: showacceptedCall ? 'flex' : 'none', justifyContent: 'center' }}>
                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center", marginTop:'40px!important'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span>  <IconButton sx={{color:'inherit'}}>
                                    <PermIdentity sx={{ fontSize: "60px" }} />
                                </IconButton></span>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center", marginTop:'-10px!important'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h5' sx={{marginTop:'20px', fontWeight:'bold'}}>{contactName ? contactName : dialerNumber}</Typography>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center",marginTop:'-10px!important'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h5' sx={{marginTop:'20px'}}>{dialerNumber}</Typography>
                            </div>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', gridColumn: "span 12", textAlign: "center", justifyContent: "center", marginTop:'-15px!important', marginBottom:'15px!important'}}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Typography variant='h6' sx={{marginTop:'20px'}}>{timer}</Typography>
                            </div>
                        </Grid>

                        {/* DTMF Buttons */}
                        <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, marginTop:'-20px!important', display: dtmfButtons ? 'flex':'none', justifyContent: 'center' }}>
                            <TextField
                                variant="outlined"
                                value={dTMFValue}
                                onChange={(event) => setDTMFValue(event.target.value)}
                                sx={{
                                    paddingLeft:"10px",
                                    paddingRight:"10px",
                                    paddingBottom: "-5px",
                                    fontSize: 20,
                                    textAlign:"center",
                                    "& .MuiInputBase-input": {
                                        textAlign: "center",
                                        fontWeight:"lighter",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        border: "none",
                                        boxShadow: "none",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                }}
                                placeholder='DTMF Tone'
                            />
                            <Grid item xs={12} sx={{paddingBottom:'10px', marginTop:'-10px'}}><Divider/></Grid>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                                <Grid item xs={4} key={number} sx={{ textAlign: 'center', padding: '0px'}}>
                                    <Button
                                        sx={{
                                            width: '35px',
                                            height: '35px',
                                            borderRadius: '50%',
                                            minWidth: '35px',
                                            padding: 0,
                                            color: 'inherit',
                                            '&:hover': {
                                                borderRadius: '50%',
                                            },
                                        }}
                                        onClick={() => sendDTMF(number.toString())}>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span style={{ fontSize: 20, marginTop: "-6px" }}>{number}</span>
                                        </div>
                                    </Button>
                                </Grid>
                            ))}

                            <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                                <Button
                                    sx={{
                                        width: '35px',
                                        height: '35px',
                                        borderRadius: '50%',
                                        minWidth: '35px',
                                        padding: 0,
                                        color: 'inherit',
                                        '&:hover': {
                                            borderRadius: '50%',
                                        },
                                    }}
                                    onClick={() => sendDTMF('*')}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span style={{ fontSize: 25, marginTop:'10px'}}>*</span>
                                    </div>
                                </Button>
                            </Grid>
                            <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                                <Button
                                    sx={{
                                        width: '35px',
                                        height: '35px',
                                        borderRadius: '50%',
                                        minWidth: '35px',
                                        padding: 0,
                                        color: 'inherit',
                                        '&:hover': {
                                            borderRadius: '50%',
                                        },
                                    }}
                                    onClick={() => sendDTMF('0')}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span style={{ fontSize: 20,}}>0</span>
                                    </div>
                                </Button>
                            </Grid>

                            <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                                <Button
                                    sx={{
                                        width: '35px',
                                        height: '35px',
                                        borderRadius: '50%',
                                        minWidth: '35px',
                                        padding: 0,
                                        color: 'inherit',
                                        '&:hover': {
                                            borderRadius: '50%',
                                        },
                                    }}
                                    onClick={() => sendDTMF('#')}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span style={{ fontSize: 20}}>#</span>
                                    </div>
                                </Button>
                            </Grid>
                            <Grid item xs={12} sx={{marginTop:'10px'}}><Divider/></Grid>
                        </Grid>

                        {/* Transfer Selection */}
                        <Grid container spacing={1} sx={{  pl:2, pr:2, pb:1, marginTop:'-10px!important', display: transferSelection ? 'flex':'none', justifyContent: 'center' }}>
                            <Grid item xs={12} sx={{ textAlign: 'center', mb: 2}}>
                                <Typography variant="body2" color="warning.main">
                                    Transfer
                                </Typography>
                            </Grid>

                            <Grid container spacing={2}>
                                {(activeTransferButton === null || activeTransferButton === 'attended-internal') && (
                                    <Grid item xs={activeTransferButton ? 12 : 6}>
                                        <Button variant="outlined" color="info" fullWidth sx={{ fontWeight: 'bold' }} onClick={() => handleTransferSelect('attended-internal')}>
                                            Attended (Internal)
                                        </Button>
                                    </Grid>
                                )}

                                {(activeTransferButton === null || activeTransferButton === 'unattended-internal') && (
                                    <Grid item xs={activeTransferButton ? 12 : 6}>
                                        <Button variant="outlined" color="primary" fullWidth sx={{ fontWeight: 'bold' }} onClick={() => handleTransferSelect('unattended-internal')}>
                                            Unattended (Internal)
                                        </Button>
                                    </Grid>
                                )}

                                {(activeTransferButton === null || activeTransferButton === 'attended-external') && (
                                    <Grid item xs={activeTransferButton ? 12 : 6}>
                                        <Button variant="outlined" color="success" fullWidth sx={{ fontWeight: 'bold' }} onClick={() => handleTransferSelect('attended-external')}>
                                            Attended (External)
                                        </Button>
                                    </Grid>
                                )}

                                {(activeTransferButton === null || activeTransferButton === 'unattended-external') && (
                                    <Grid item xs={activeTransferButton ? 12 : 6}>
                                        <Button variant="outlined" color="warning" fullWidth sx={{ fontWeight: 'bold' }} onClick={() => handleTransferSelect('unattended-external')}>
                                            Unattended (External)
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>

                            {isInWarmTransfer && (
                                <>
                                    <Grid item xs={6} sx={{ textAlign: 'center', padding: '5px' }}>
                                        <Button variant="outlined" color="success" fullWidth disabled={!isConsultationReady} onClick={completeWarmTransfer}>
                                            Complete
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6} sx={{ textAlign: 'center', padding: '5px' }}>
                                        <Button variant="outlined" color="error" fullWidth sx={{fontWeight:'bold'}} onClick={cancelWarmTransfer}>
                                            Cancel
                                        </Button>
                                    </Grid>
                                </>
                            )}
                        </Grid>

                        {/* Transfer External Section */}
                        <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, marginTop:'-10px!important', display: externalAttendedTransferCalls ? 'flex':'none', justifyContent: 'center' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={11}>
                                    <TextField
                                        placeholder="Enter External Number"
                                        value={externalAttendedDisplay}
                                        onChange={(event) => setExternalAttendedDisplay(event.target.value)}
                                        sx={{
                                            color:"inherit",
                                            marginTop:"15px",
                                            paddingLeft:"10px",
                                            paddingRight:"10px",
                                            paddingBottom: "-5px",
                                            marginLeft: '-20px',
                                            fontSize: 20,
                                            "& .MuiInputBase-input": {
                                                fontWeight:"lighter",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                border: "none",
                                                boxShadow: "none",
                                            },
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            borderRadius: '0px 7px 7px 0px',
                                            marginLeft: '-30px',
                                            marginBottom: '-40px',
                                            marginTop:"15px",
                                            paddingBottom: "-5px",
                                            fontSize: 20,
                                        }}
                                        onClick={() => {forwardAttendedExternalCall(externalAttendedDisplay);}}
                                    >
                                        <Redo />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, marginTop:'-10px!important', display: externalTransferCalls ? 'flex':'none', justifyContent: 'center' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={11}>
                                    <TextField
                                        placeholder="Enter External Number"
                                        value={externalDisplay}
                                        onChange={(event) => setExternalDisplay(event.target.value)}
                                        sx={{
                                            color:"inherit",
                                            marginTop:"15px",
                                            paddingLeft:"10px",
                                            paddingRight:"10px",
                                            paddingBottom: "-5px",
                                            marginLeft: '-20px',
                                            fontSize: 20,
                                            "& .MuiInputBase-input": {
                                                fontWeight:"lighter",
                                            },
                                            "& .MuiOutlinedInput-root": {
                                                border: "none",
                                                boxShadow: "none",
                                            },
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                border: "none",
                                            },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            borderRadius: '0px 7px 7px 0px',
                                            marginLeft: '-30px',
                                            marginBottom: '-40px',
                                            marginTop:"15px",
                                            paddingBottom: "-5px",
                                            fontSize: 20,
                                        }}
                                        onClick={() => {forwardCall(externalDisplay);}}
                                    >
                                        <Redo />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Transfer Internal Section */}
                        <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, marginTop:'-20px!important', display: transferCalls ? 'flex':'none', justifyContent: 'center' }}>
                            <TextField
                                fullWidth
                                select
                                label="Who to Transfer To"
                                placeholder="Who to Transfer To"
                                name="transfer_extn"
                                SelectProps={{
                                    displayEmpty: true,
                                }}
                                sx={{
                                    color:"inherit",
                                    marginTop:"15px",
                                    paddingLeft:"10px",
                                    paddingRight:"10px",
                                    paddingBottom: "-5px",
                                    fontSize: 20,
                                    textAlign:"center",
                                    "& .MuiInputBase-input": {
                                        textAlign: "center",
                                        fontWeight:"lighter",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        border: "none",
                                        boxShadow: "none",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                    },
                                }}
                                value={transferExtension}
                                onChange={handleTransferChange}
                                required
                            >
                                <MenuItem disabled selected> Who to Transfer Call To</MenuItem>
                                {transferToUsers.map((row, index) => (
                                    <MenuItem key={index} value={row.user_extension}>{row.user_name} - {row.user_extension}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        {/* Conference Dial Panel (3-party, browser-mixed) */}
                        <Grid container spacing={1} sx={{ pl:2, pr:2, pb:1, marginTop:'-10px!important', display: conferencePanel ? 'flex':'none', justifyContent: 'center' }}>
                            <Grid item xs={12} sx={{ textAlign: 'center', mb: 1 }}>
                                <Typography variant="body2" color="warning.main" sx={{ fontWeight: 'bold' }}>
                                    Add to Call (Conference)
                                </Typography>
                                {conferenceStatus && (
                                    <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
                                        {conferenceStatus}
                                    </Typography>
                                )}
                            </Grid>

                            <Grid container spacing={1} sx={{ alignItems: 'center' }}>
                                <Grid item xs={9}>
                                    <TextField
                                        placeholder="Number to add"
                                        value={conferenceDisplay}
                                        onChange={(event) => setConferenceDisplay(event.target.value)}
                                        disabled={isConfDialing || isConfReady}
                                        fullWidth
                                        sx={{
                                            "& .MuiInputBase-input": { fontWeight: "lighter", textAlign: "center" },
                                            "& .MuiOutlinedInput-root": { border: "none", boxShadow: "none" },
                                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                            "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        disabled={!conferenceDisplay || isConfDialing || isConfReady}
                                        onClick={() => conferenceDial(conferenceDisplay)}
                                        sx={{ minWidth: 0 }}
                                    >
                                        <Call sx={{ fontSize: '1.2rem' }} />
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                {(isConfDialing || isConfReady) && (
                                    <Grid item xs={6}>
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            fullWidth
                                            sx={{ fontWeight: 'bold' }}
                                            onClick={cancelConferenceDial}
                                        >
                                            Drop
                                        </Button>
                                    </Grid>
                                )}
                                <Grid item xs={(isConfDialing || isConfReady) ? 6 : 12}>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        fullWidth
                                        disabled={!isConfReady}
                                        sx={{ fontWeight: 'bold', color: 'inherit' }}
                                        onClick={joinConferenceCall}
                                    >
                                        Merge
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="text"
                                        color="inherit"
                                        fullWidth
                                        size="small"
                                        onClick={cancelConference}
                                    >
                                        Close
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* 3-WAY CONFERENCE active caption */}
                        {isConfJoined && (
                            <Grid item xs={12} sx={{ textAlign: 'center', mt: '-8px', mb: 1 }}>
                                <Typography variant="caption" sx={{ color: '#FF9800', fontWeight: 'bold', letterSpacing: '0.5px' }}>
                                    3-WAY CONFERENCE
                                </Typography>
                            </Grid>
                        )}

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => {toggleMute();}}
                            >
                                {isMuted ? <MicOff style={{ fontSize: '1.5rem', color: "#c62828"}} /> : <Mic sx={{ fontSize: '1.5rem',color: 'inherit'}} />}
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => {toggleHold();}}
                            >
                                {isHeld ? <Pause style={{ fontSize: '1.5rem', color: "#c62828"}} /> : <PlayArrow sx={{ fontSize: '1.5rem',color: 'inherit'}} />}
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => {toggleTransferSelection();}}
                            >
                                {transferSelection ? <Redo style={{ fontSize: '1.5rem', color: "#c62828"}} /> : <Redo sx={{ fontSize: '1.5rem',color: 'inherit'}} />}
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={handleOpenAddDispositionModal}
                            >
                                <NoteAlt sx={{ fontSize: '1.5rem', color: 'inherit' }} />
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => {startConferenceCall();}}
                            >
                                <PeopleOutline
                                    sx={{
                                        fontSize: '1.5rem',
                                        color: isConfJoined ? '#FF9800' : (conferencePanel ? '#c62828' : 'inherit'),
                                    }}
                                />
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: 'inherit',
                                    color:'inherit',
                                }}
                                onClick={() => toggleDTMF()}
                            >
                                {dtmfButtons ? <Keyboard style={{ fontSize: '1.5rem', color: "#c62828"}} /> : <Keyboard sx={{ fontSize: '1.5rem',color: 'inherit'}} />}
                            </IconButton>
                        </Grid>

                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 2 ,fontSize: 14}}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.error.main} !important`,
                                }}
                                onClick={hangUpCall}
                            >
                                <LocalPhone sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>
                        </Grid>
                    </Grid>

                    {/* Campaign wrap-up countdown */}
                    {wrapUpSeconds > 0 && campaignMode && (
                        <Box
                            sx={{
                                mx: 1.5,
                                mt: 1,
                                mb: 1,
                                p: 1.5,
                                borderRadius: 2,
                                textAlign: 'center',
                                backgroundColor: (theme) =>
                                    theme.palette.mode === 'dark'
                                        ? 'rgba(255, 152, 0, 0.18)'
                                        : 'rgba(255, 152, 0, 0.12)',
                                border: '1px solid',
                                borderColor: 'warning.main',
                            }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: 600, color: 'warning.main' }}>
                                Next call in
                            </Typography>
                            <Typography
                                variant="h4"
                                sx={{ fontWeight: 700, color: 'warning.main', lineHeight: 1.2, my: 0.5 }}
                            >
                                {wrapUpSeconds}s
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'text.secondary' }}>
                                Contact {currentContactIndex + 1} of {campaignContacts.length}
                            </Typography>
                            <Button
                                variant="contained"
                                color="warning"
                                size="small"
                                fullWidth
                                onClick={skipWrapUp}
                                sx={{ fontWeight: 600 }}
                            >
                                Next Call Now
                            </Button>
                        </Box>
                    )}

                    {/* DIALER BUTTONS */}
                    <TextField
                        variant="outlined"
                        value={dialdisplay}
                        onChange={(event) => setDialDisplay(event.target.value)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                                if (dialdisplay.trim() !== '') {
                                    makeCall();
                                }
                            }
                        }}
                        sx={{
                            display: displayInput ? 'flex' : 'none',
                            paddingLeft:"10px",
                            paddingRight:"10px",
                            textAlign:"center",
                            "& .MuiInputBase-input": {
                                fontSize: "20px",
                                textAlign: "center",
                                fontWeight:"lighter",
                            },
                            "& .MuiOutlinedInput-root": {
                                border: "none",
                                boxShadow: "none",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                        }}
                        placeholder='Enter Phone Number'
                    />

                    {/* Contact match list — under the number input; each row pastes its number */}
                    {displayInput && contactMatches.length > 0 && (
                        <Box
                            sx={{
                                mx: 1.5,
                                mt: 0.5,
                                mb: 0.75,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 0.75,
                                maxHeight: 180,
                                overflowY: 'auto',
                            }}
                        >
                            {contactMatches.map((m, i) => {
                                const canPaste = Boolean(m.phone_number);
                                return (
                                    <Box
                                        key={`${m.phone_number || m.name || 'm'}-${i}`}
                                        onClick={() => canPaste && applyMatchedContact(m)}
                                        title={canPaste ? `Use ${m.phone_number}` : undefined}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            px: 1.5,
                                            py: 1.1,
                                            borderRadius: 2,
                                            cursor: canPaste ? 'pointer' : 'default',
                                            backgroundColor: (theme) =>
                                                theme.palette.mode === 'dark'
                                                    ? 'rgba(33, 150, 243, 0.18)'
                                                    : 'rgba(33, 150, 243, 0.10)',
                                            border: '1px solid',
                                            borderColor: (theme) =>
                                                theme.palette.mode === 'dark'
                                                    ? 'rgba(33, 150, 243, 0.45)'
                                                    : 'rgba(33, 150, 243, 0.35)',
                                            transition: 'background-color 0.15s ease, border-color 0.15s ease, transform 0.1s ease',
                                            '&:hover': canPaste
                                                ? {
                                                    backgroundColor: (theme) =>
                                                        theme.palette.mode === 'dark'
                                                            ? 'rgba(33, 150, 243, 0.28)'
                                                            : 'rgba(33, 150, 243, 0.18)',
                                                    borderColor: 'primary.main',
                                                    transform: 'translateY(-1px)',
                                                }
                                                : undefined,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: '17px',
                                                fontWeight: 700,
                                                color: 'primary.main',
                                                lineHeight: 1.2,
                                                textAlign: 'center',
                                            }}
                                        >
                                            {m.name || 'Unknown'}
                                        </Typography>
                                        {m.phone_number && (
                                            <Typography
                                                sx={{
                                                    fontSize: '13px',
                                                    fontWeight: 500,
                                                    color: 'text.secondary',
                                                    mt: 0.3,
                                                    textAlign: 'center',
                                                }}
                                            >
                                                {m.phone_number}
                                            </Typography>
                                        )}
                                        {canPaste && ('')}
                                    </Box>
                                );
                            })}
                        </Box>
                    )}

                    <Grid container spacing={0.001} sx={{  pl:2, pr:2, pb:1, display: dialerButtons ? 'flex':'none', justifyContent: 'center' }}>
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                            <Grid item xs={4} key={number} sx={{ textAlign: 'center', padding: '0px'}}>
                                <Button
                                    sx={{
                                        width: '40px',
                                        height: '65px',
                                        borderRadius: '100%',
                                        color: 'inherit',
                                    }}
                                    onClick={() => handleDialButtonClick(number.toString())}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span style={{ fontSize: 25, marginTop: number === 1 ? "-26px" : "-6px" }}>{number}</span>
                                        <span style={{ fontSize: 12, marginTop: "-10px" }}>
                                            {number === 1 ? "" : number === 2 ? "ABC" : number === 3 ? "DEF": number === 4 ? "GHI": number === 5 ? "JKL": number === 6 ? "MNO": number === 7 ? "PQRS": number === 8 ? "TUV": number === 9 ? "WXYZ" : ""}
                                        </span>
                                    </div>
                                </Button>
                            </Grid>
                        ))}

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <Button
                                sx={{
                                    width: '40px',
                                    height: '65px',
                                    borderRadius: '100%',
                                    color:'inherit',
                                }}
                                onClick={() => handleDialButtonClick('*')}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <span style={{ fontSize: 30}}>*</span>
                                </div>
                            </Button>
                        </Grid>
                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <Button
                                sx={{
                                    width: '40px',
                                    height: '65px',
                                    borderRadius: '100%',
                                    color:'inherit',
                                }}
                                onClick={() => handleDialButtonClick('0')}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <span style={{ fontSize: 25,}}>0</span>
                                </div>
                            </Button>
                        </Grid>

                        <Grid item xs={4} sx={{ textAlign: 'center', padding: '0px'}}>
                            <Button
                                sx={{
                                    width: '40px',
                                    height: '65px',
                                    borderRadius: '100%',
                                    color:'inherit',
                                }}
                                onClick={() => handleDialButtonClick('#')}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <span style={{ fontSize: 25}}>#</span>
                                </div>
                            </Button>
                        </Grid>
                        <Grid item xs={12} sx={{ mb:'10px',textAlign: 'center' }}>
                            <Divider/>
                        </Grid>

                        <Grid item xs={4} sx={{ mt: 0.5, textAlign: 'center' }}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    color:'inherit',
                                }}
                                onClick={() => handleDialButtonClick('+')}
                            >
                                <AddIcon sx={{fontSize: '1.5rem'}}/>
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ mt: 0.5, textAlign: 'center' }}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: `${theme.palette.success.main} !important`,
                                }}
                                onClick={makeCall}
                            >
                                <Call sx={{ fontSize: '1.5rem', color: 'white' }} />
                            </IconButton>
                        </Grid>

                        <Grid item xs={4} sx={{ mt: 0.5, textAlign: 'center' }}>
                            <IconButton
                                color="primary"
                                sx={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    color:'inherit',
                                }}
                                onClick={() => handleButtonDelete()}
                            >
                                <BackspaceIcon sx={{fontSize: '1.5rem'}}/>
                            </IconButton>
                        </Grid>
                    </Grid>

                    {/* Add Disposition Modal */}
                    <Modal
                        open={openAddDispositionModal}
                        onClose={handleCloseAddDispositionModal}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <Box sx={modalStyle}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <h3 id="modal-title">New Disposition</h3>
                                <Box display="flex" justifyContent="right">
                                    <Cancel onClick={handleCloseAddDispositionModal} sx={{ cursor: 'pointer' }} />
                                </Box>
                            </Box>
                            <form onSubmit={handleDispositionSubmit}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Disposition Contact"
                                            name="disposition_contact"
                                            onChange={(event) => setModalDispositionContact(event.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            required
                                            value={modalDispositionContact}
                                            sx={{marginTop:"5px"}}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Disposition Owner"
                                            placeholder="Disposition Owner"
                                            variant="outlined"
                                            fullWidth
                                            name="disposition_owner"
                                            required
                                            sx={{marginTop:"5px",display:'none'}}
                                            value={sessionStorage.getItem('extension')}
                                        />
                                        <TextField
                                            fullWidth
                                            select
                                            label="Call Type"
                                            name="call_type"
                                            sx={{marginTop:"5px"}}
                                            onChange={(event) => {
                                                handleInputChange(event);
                                                // Modal-local only — parent callType is left alone
                                                // so a new call cannot overwrite this form.
                                                setModalCallType(event.target.value);
                                            }}
                                            required
                                            value={modalCallType}
                                        >
                                            <MenuItem>Select Type Of Call</MenuItem>
                                            <MenuItem value="incoming">Incoming</MenuItem>
                                            <MenuItem value="outgoing">Outgoing</MenuItem>
                                            <MenuItem value="whatsapp">WhatsApp</MenuItem>
                                            <MenuItem value="instagram">Instagram</MenuItem>
                                            <MenuItem value="x">X</MenuItem>
                                            <MenuItem value="facebook">Facebook</MenuItem>
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            select
                                            label="Disposition Category"
                                            name="disposition_category"
                                            onChange={handleInputCatChange}
                                            sx={{marginTop:"5px"}}
                                        >
                                            <MenuItem disabled selected>Select Category</MenuItem>
                                            {dispositionCategory.map((row) => (
                                                <MenuItem key={row.id} value={row.category}>
                                                    {row.category}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            select
                                            label="Disposition Sub Category"
                                            name="disposition_sub_category"
                                            onChange={handleInputChange}
                                            sx={{marginTop:"5px"}}
                                        >
                                            <MenuItem value="">Select Sub Category</MenuItem>
                                            {subCategorDataDropDown.map((row) => (
                                                <MenuItem key={row.id} value={row.sub_category}>
                                                    {row.sub_category}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            select
                                            label="Disposition"
                                            name="disposition"
                                            sx={{marginTop:"5px"}}
                                            onChange={handleInputChange}
                                            required
                                            value={newDisposition.disposition}
                                        >
                                            <MenuItem value="">Select Disposition</MenuItem>
                                            <MenuItem value="Call Back">Call Back</MenuItem>
                                            {dispositionList.map((disposition, i) => (
                                                <MenuItem key={i} value={disposition.disposition_name}>{disposition.disposition_name}</MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            multiline
                                            rows={2}
                                            label="Extra Info"
                                            placeholder="Extra Info"
                                            onChange={handleInputChange}
                                            variant="outlined"
                                            fullWidth
                                            name="disposition_info"
                                            required
                                            sx={{marginTop:"5px"}}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button type="submit" variant="contained" color='info' sx={{padding:"10px",marginTop:"10px",width:"100%"}}>Submit Disposition</Button>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Button type="button" variant="contained" color='info' sx={{display:dispositionHangupButton, padding:"10px",marginTop:"10px",width:"100%",backgroundColor:"#c62828", color:'inherit'}} onClick={() => hangUpCall()}>Hang Up</Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Box>
                    </Modal>
                </span>}

                {selectedDailerTab === 3 &&  <span>
                    <Box sx={{ height: "auto", overflowY: "auto"}}>
                        <Grid container spacing={2} sx={{p:4}}>
                            {sessionStorage.getItem("user_level") !== "agent" && (
                                <>
                                    <Grid item xs={7} sx={{textAlign:"left"}}><Box sx={{fontSize:"13px", marginTop:"10px"}}>Enable Call</Box></Grid>
                                    <Grid item xs={5} sx={{textAlign:"right"}}>
                                        <Switch checked={callEnabled} onChange={handleCallEnableChange} color="success" />
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={7} sx={{textAlign:"left"}}><Box sx={{fontSize:"13px", marginTop:"10px"}}>Take Break</Box></Grid>
                            <Grid item xs={5} sx={{textAlign:"right"}}>
                                <Switch checked={takeBreak} onChange={handleTakeBreakChange} disabled={autoAnswer} color="error" />
                            </Grid>

                            <Grid item xs={7} sx={{textAlign:"left"}}><Box sx={{fontSize:"13px", marginTop:"10px"}}>Auto Answer</Box></Grid>
                            <Grid item xs={5} sx={{textAlign:"right"}}>
                                <Switch checked={autoAnswer} onChange={handleAutoAnswerChange} disabled={takeBreak} color="info" />
                            </Grid>

                            <Grid item xs={7} sx={{textAlign:"left"}}><Box sx={{fontSize:"13px", marginTop:"10px", color: flashSwitch ? 'warning.light' : 'inherit', transition: 'border-color 0.15s ease'}}> {campaignMode ? "Campaign On" : "Campaign Mode"}</Box></Grid>
                            <Grid item xs={5} sx={{textAlign:"right"}}>
                                <Switch
                                    checked={campaignMode}
                                    onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        if (isChecked) {
                                            startCampaign();
                                            notifyAutoDialer(true);
                                        } else {
                                            stopCampaign();
                                            notifyAutoDialer(false);
                                        }
                                    }}
                                    color="warning"
                                    disabled={false}
                                />
                            </Grid>

                            {campaignMode && (
                                <Grid item xs={12}>
                                    <Divider/>
                                    <Typography variant="body2">
                                        Contact {currentContactIndex + 1} of {campaignContacts.length}
                                    </Typography>
                                    {wrapUpSeconds > 0 && (
                                        <Box sx={{ mt: 1, textAlign: 'center' }}>
                                            <Typography variant="body2" sx={{ color: 'warning.main', fontWeight: 600 }}>
                                                Next call in {wrapUpSeconds}s
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                color="warning"
                                                size="small"
                                                onClick={skipWrapUp}
                                                sx={{ mt: 0.5, fontWeight: 600 }}
                                            >
                                                Next Call Now
                                            </Button>
                                        </Box>
                                    )}
                                </Grid>
                            )}
                        </Grid>

                        <Modal open={openTakingBreakModal} aria-labelledby="modal-title" aria-describedby="modal-description">
                            <Box sx={modalStyle}>
                                <div className="modal-content">
                                    <Box sx={{display: 'flex', justifyContent: 'center', width: '100%' }}>
                                        <h2 id="modal-title" sx={{textAlign:'center'}}>Break ( {timer} )</h2>
                                        <Box display="flex" justifyContent="right"></Box>
                                    </Box>
                                    <form>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    select
                                                    label="Break Type"
                                                    name="break_type"
                                                    sx={{marginTop:"10px", display: breakDrop}}
                                                    onChange={handleInputBreakChange}
                                                    required="true"
                                                >
                                                    <MenuItem disabled>Select</MenuItem>
                                                    <MenuItem value="Lunch Break">Lunch Break</MenuItem>
                                                    <MenuItem value="Short Break">Short Break</MenuItem>
                                                    <MenuItem value="Scheduled Break">Scheduled Break</MenuItem>
                                                    <MenuItem value="Team Meetings">Team Meetings</MenuItem>
                                                    <MenuItem value="Emergency Break">Emergency Break</MenuItem>
                                                    <MenuItem value="Rotational Break">Rotational Break</MenuItem>
                                                    <MenuItem value="Quiet Time Break">Quiet Time Break</MenuItem>
                                                </TextField>
                                                <Box sx={{display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                    <h1>{breakType}</h1>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Button type="button" variant="contained" color="success" sx={{padding:"10px", marginTop:"10px", color:'inherit', width:'100%', display: breakBtn}} onClick={() => handleTakingBreakClose(false)}>End Break</Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </div>
                            </Box>
                        </Modal>
                    </Box>
                </span>}

                {selectedDailerTab === 1 &&  <span>
                    <Box display='flex' sx={{ alignItems: 'center',alignContent: 'center', justifyContent: 'space-between',}}>
                        <TextField
                            variant="outlined"
                            sx={{
                                paddingLeft:"5px",
                                paddingRight:"5px",
                                textAlign:"center",
                                "& .MuiInputBase-input": {
                                    fontSize: "15px",
                                    textAlign: "center",
                                    fontWeight:"lighter",
                                },
                                "& .MuiOutlinedInput-root": {
                                    border: "none",
                                    boxShadow: "none",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                            }}
                            placeholder='Search Notification'
                        />
                        <Button variant="contained" color="error" sx={{marginRight:'5px'}}>Clear</Button>
                    </Box>
                </span>}

                {selectedDailerTab === 2 &&  <span>
                    <Grid container spacing={2} sx={{ p: 2 }}>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" fullWidth onClick={() => startCampaign()} disabled={campaignMode}>
                                Start Campaign
                            </Button>
                        </Grid>

                        {campaignMode && (
                            <>
                                <Grid item xs={12}>
                                    <Typography variant="body2">
                                        Contact {currentContactIndex + 1} of {campaignContacts.length}
                                    </Typography>
                                    {wrapUpSeconds > 0 && (
                                        <Box sx={{ mt: 1, textAlign: 'center' }}>
                                            <Typography variant="body2" sx={{ color: 'warning.main', fontWeight: 600 }}>
                                                Next call in {wrapUpSeconds}s
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                color="warning"
                                                size="small"
                                                onClick={skipWrapUp}
                                                sx={{ mt: 0.5, fontWeight: 600 }}
                                            >
                                                Next Call Now
                                            </Button>
                                        </Box>
                                    )}
                                </Grid>

                                <Grid item xs={12}>
                                    <Button variant="contained" color="error" fullWidth onClick={stopCampaign}>
                                        Stop Campaign
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </span>}
                {selectedDailerTab === 5 &&  <span></span>}
                {selectedDailerTab === 6 &&  <span></span>}
            </Drawer>
            <audio id="local-audio" autoPlay muted></audio>
            <audio id="remote-audio" autoPlay></audio>
            <audio id="conference-audio" autoPlay></audio>
        </Box>
    );
};

export default DialBar;